<template>
  <div
    v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div
      class="container-box"
      :style="{ background: theme.bgColor + ' url(' + ('https://survey.iscn.org.cn/system/mallMiniProgram/img/dataReport2025/' + theme.bg) + ') no-repeat top center', }">
      <div>
        <section class="calcu-content">
          <div class="content-table">
            <div class="innerBg">
              <img
                :src="`https://survey.iscn.org.cn/system/mallMiniProgram/img/dataReport2025/${theme.lableBg}`"
              />
            </div>
            <div class="innerBg-box"></div>
            <div class="tab-box">
              <div class="selection-area">
                <div v-for="item in activeTab" :key="item.active" @click="changeTab(item.active)">
                  <template v-if="item.children.length>0">
                    <el-dropdown :trigger="isPc?'hover':'click'" @command="clickDropdownMenu" placement="bottom-start">
                      <div
                        :class="item.active==12?'sel-tab long-5-sel-tab':(item.active==1||item.active==2?'sel-tab long-4-sel-tab':(item.active==6?'sel-tab long-3-sel-tab':'sel-tab'))"
                        :style="{ background: 'url(' + require('./../assets/' + (item.show?theme.tabbt:'greytabbt.png')) + ') no-repeat 0 0/100% 100%', }"
                      >
                        <span><span>{{ item.title }}</span><span v-if="isPc">{{ item.titleS }}{{ item.titleF }}</span></span>
                        <span v-if="!isPc">{{ item.titleS }}</span>
                        <span v-if="!isPc">{{ item.titleF }}</span>
                        <i v-if="isPc" class="add-tips">{{ item.tip }}</i>
                      </div>
                      <el-dropdown-menu v-if="item.children.length>0" slot="dropdown" :class="theme.tabsBg">
                        <el-dropdown-item v-for="it in item.children" :command="it" :key="it.id">{{it.title}}</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </template>
                  <template v-else>
                    <div
                      :class="item.active==12?'sel-tab long-5-sel-tab':(item.active==1||item.active==2?'sel-tab long-4-sel-tab':(item.active==6?'sel-tab long-3-sel-tab':'sel-tab'))"
                      :style="{ background: 'url(' + require('./../assets/' + (item.show?theme.tabbt:'greytabbt.png')) + ') no-repeat 0 0/100% 100%', }"
                    >
                      <span><span>{{ item.title }}</span><span v-if="isPc">{{ item.titleS }}{{ item.titleF }}</span></span>

                      <span v-if="!isPc">{{ item.titleS }}</span>
                      <span v-if="!isPc">{{ item.titleF }}</span>
                      <i v-if="isPc" class="add-tips">{{ item.tip }}</i>
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div class="table-box">
              <div class="table">
                <div class="sel-header" :style="{ background: theme.themeColor }">
                  <div class="sel-tips">
                    <span v-if="isPc||nowActive.active == 1||nowActive.active == 6||nowActive.active == 12">
                      {{ nowActive.title }}{{ nowActive.titleS }}{{ nowActive.titleF }}{{ nowActive.tip }}
                    </span>
                    <span v-else-if="nowActive.active === 2">
                      {{ filterActive(areaActiveName) }}
                    </span>
                    <span v-else-if="nowActive.active === 8">
                      {{ filterActive(volunteerActiveName) }}
                    </span>
                    <span v-else-if="nowActive.active === 5">
                      {{ filterActive(unitActiveName) }}
                    </span>
                    <span v-else-if="nowActive.active === 11">
                      {{ filterActive(UniversityActiveName) }}
                    </span>
                    <span v-else-if="nowActive.active === 10">
                      {{ nowPosterData.title }}
                    </span>
                    <div
                      v-if="nowActive.active == 1 ? true : false"
                      class="tips-top"
                    >
                      <span class="top-link" @click="openIframe">总数Top10</span>
                      <!-- 全国企业按所属名称统计 -->
                      <span class="top-link" @click="byCategoryFindTop('企业',10)">全国企业Top10</span>
                      <span class="top-link" @click="educationCollect('企业')" >全国企业</span>
                      <!-- 全国学校:高校按高校名称名称统计，学校按所属名称统计 -->
                      <span class="top-link" @click="byCategoryFindTop('学校',10)" >全国学校Top10</span>
                      <span class="top-link" @click="educationCollect('学校')" >全国学校</span>
                      <span class="top-link" @click="cityCollect" >城市Top100</span>
                    </div>
                    <div
                      v-if="nowActive.active == 2 ? true : false"
                      class="tips-top"
                    >
                      <span class="top-link" @click="areaCityCollect" >城市Top100</span>
                    </div>
                    <div class="update-time" v-if="isPc">
                      数据统计截止到 <span v-if="updateTime">{{updateTime}}</span>
                    </div>
                  </div>
                </div>
                <!-- 筛选工具栏 -->
                <el-row :gutter="10">
                  <div style="text-align:right;margin-top:5px;margin-right:10px;" v-if="!isPc">
                  数据统计截止到 <span v-if="updateTime">{{updateTime}}</span>
                  </div>
                  <div v-show="nowActive.active == 8&&isPc" class="tabs-box tabs-box-3">
                    <el-row :gutter="10">
                      <el-col :span = "24">
                        <el-tabs :class="theme.tabsBg"
                          type="card"
                          style="width: 100%;"
                          v-model="volunteerActiveName"
                          @tab-click="changeVolunteerTabelTab">
                          <template v-for="item in nowActive.children">
                            <el-tab-pane :label="item.title" :name="item.identification">
                            </el-tab-pane>
                          </template>
                        </el-tabs>
                      </el-col>
                    </el-row>
                  </div>
                  <div v-show="nowActive.active == 2&&isPc" class="tabs-box tabs-box-2">
                    <el-row :gutter="10">
                      <el-col :span = "24">
                        <el-tabs :class="theme.tabsBg"
                          type="card" style="width: 100%;"
                          v-model="areaActiveName"
                          @tab-click="changeAreaTabelTab">
                          <template v-for="item in nowActive.children">
                            <el-tab-pane :label="item.title" :name="item.identification">
                            </el-tab-pane>
                          </template>
                        </el-tabs>
                      </el-col>
                    </el-row>
                  </div>
                  <div v-show="nowActive.active == 5&&isPc" class="tabs-box tabs-box-2">
                    <el-row :gutter="10">
                      <el-col :span = "24">
                        <el-tabs :class="theme.tabsBg"
                          type="card" style="width: 100%;"
                          v-model="unitActiveName"
                          @tab-click="changeUnitTabelTab">
                          <template v-for="item in nowActive.children">
                            <el-tab-pane :label="item.title" :name="item.identification">
                            </el-tab-pane>
                          </template>
                        </el-tabs>
                      </el-col>
                    </el-row>
                  </div>
                  <div v-show="nowActive.active == 11&&isPc" class="tabs-box tabs-box-2">
                    <el-row :gutter="10">
                      <el-col :span = "24">
                        <el-tabs :class="theme.tabsBg"
                          type="card" style="width: 100%;"
                          v-model="UniversityActiveName"
                          @tab-click="changeUniversityTabelTab">
                          <template v-for="item in nowActive.children">
                            <el-tab-pane :label="item.title" :name="item.identification">
                            </el-tab-pane>
                          </template>
                        </el-tabs>
                      </el-col>
                    </el-row>
                  </div>
                  <!-- 1:省市2:区域5:发起单位 6:各链接 -->
                  <div :class="(nowActive.active==1||nowActive.active==2)?'tool-bar end-tool-bar':'tool-bar'">
                    <el-col
                      :span="isPc?6 : (unitActiveName=='second'?18 : 12)"
                      v-show="nowActive.active==5"
                    >
                      <div class="tool-input">
                        <el-input
                          :placeholder="unitActiveName==='second'?'请输入推荐单位' : (unitActiveName === 'three'?'请输入联合发起单位' : '请输入发起单位')"
                          v-model="toolData.recommended"
                          clearable
                          :size="isPc?'medium':'mini'"
                        >
                        </el-input>
                      </div>
                    </el-col>
                    <el-col
                      :span="isPc? 6 : (unitActiveName=='second'?6 : 12) "
                      v-show="nowActive.active == 5"
                    >
                      <el-button
                        :loading="loading"
                        @click="searchEvent"
                        plain
                        :size="isPc?'medium':'mini'"
                      >搜索</el-button>
                      <el-button
                        v-if="unitActiveName==='first'||unitActiveName==='three'"
                        @click="exportData"
                        plain
                        :size="isPc?'medium':'mini'"
                        >导出</el-button
                      >
                    </el-col>
                    <!-- 服务站,服务队 -->
                    <template v-if="nowActive.active == 8 && !showMap">
                      <el-col :span="isPc? 6 : 12 ">
                        <div class="tool-input">
                          <el-input
                            placeholder="请输入关键字搜索"
                            v-model="toolData.volunteerOrgName"
                            clearable
                            :size="isPc?'medium':'mini'"
                          >
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="isPc? 6 : 12 ">
                        <el-button
                          :loading="loading"
                          @click="searchEvent"
                          plain
                          :size="isPc?'medium':'mini'"
                          >搜索</el-button
                        >
                        <el-button
                          @click="exportData"
                          plain
                          :size="isPc?'medium':'mini'"
                          >导出</el-button
                        >
                      </el-col>
                    </template>
                    <template v-if="nowActive.active == 8 && (volunteerActiveName === 'first' || volunteerActiveName === 'second') && showMap">
                      <el-col :span="isPc? 24 : 24 ">
                        <div style="text-align:right;display: flex; justify-content: flex-end;">
                          <el-button
                            @click="tableEvent"
                            plain
                            :size="isPc?'medium':'mini'"
                            >表格统计</el-button>
                        </div>
                      </el-col>
                    </template>
                    <template v-if="nowActive.active == 11&&UniversityActiveName==='first'">
                      <el-col :span="isPc? 6 : 12 ">
                        <div class="tool-input">
                          <el-input
                            placeholder="请输入关键字搜索"
                            v-model="toolData.university"
                            clearable
                            :size="isPc?'medium':'mini'"
                          >
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="isPc? 6 : 12 ">
                        <el-button
                          :loading="loading"
                          @click="searchEvent"
                          plain
                          :size="isPc?'medium':'mini'"
                          >搜索</el-button
                        >
                        <el-button
                          @click="exportData"
                          plain
                          :size="isPc?'medium':'mini'"
                          >导出</el-button
                        >
                      </el-col>
                    </template>

                    <el-col :span="isPc? 4 : 8 "
                      v-show="nowActive.active == 6">
                      <div
                        class="tool-input"
                      >
                        <el-select
                          v-model="toolData.province"
                          @change="changeProvince"
                          filterable
                          clearable
                          placeholder="请选择省"
                          :size="isPc?'medium':'mini'"
                        >
                          <el-option
                            v-for="item in provinceList"
                            :key="item.province"
                            :label="item.province"
                            :value="item.province"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </el-col>
                    <el-col :span="isPc? 4 : 8 "
                      v-show="nowActive.active == 6">
                      <div
                        class="tool-input"
                      >
                        <el-select
                          v-model="toolData.city"
                          filterable
                          clearable
                          placeholder="请选择市"
                          :size="isPc?'medium':'mini'"
                        >
                          <el-option
                            v-for="item in cityList"
                            :key="item.city"
                            :label="item.city"
                            :value="item.city"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </el-col>
                    <el-col :span="isPc? 5 : 8 "
                      v-show="nowActive.active == 6">
                      <div
                        class="tool-input"
                      >

                        <el-cascader
                          v-model="toolData.category"
                          :options="sortList"
                          :props="{ checkStrictly: true, value: 'id', label: 'categoryName' }"
                          clearable
                          filterable
                          placeholder="请选择分类"
                          :size="isPc?'medium':'mini'"
                          style="width: 100%;"
                        >
                        </el-cascader>
                      </div>
                    </el-col>
                    <el-col :span="isPc? 5 : 12 "
                      v-show="nowActive.active == 6">
                      <div
                        class="tool-input"
                      >
                        <el-input
                          placeholder="请输入所属名称或来源名称或ID"
                          v-model="toolData.sourceName"
                          clearable
                          :size="isPc?'medium':'mini'"
                        >
                        </el-input>
                      </div>
                    </el-col>
                    <el-col :span="isPc? 6 : 12 "
                      v-show="nowActive.active == 6">
                      <el-button
                        :loading="loading"
                        @click="searchEvent"
                        plain
                        :size="isPc?'medium':'mini'"
                        >搜索</el-button
                      >
                      <el-button
                        @click="exportData"
                        plain
                        :size="isPc?'medium':'mini'"
                        >导出</el-button
                      >
                    </el-col>
                    <el-col :span="24"
                      v-show="nowActive.active == 2 && !showMap">
                      <div class="flex-right">
                        <el-button
                          @click="mapEvent"
                          plain
                          :size="isPc?'medium':'mini'"
                        >地图统计</el-button>
                        <el-button
                          @click="exportData"
                          plain
                          :size="isPc?'medium':'mini'"
                        >导出</el-button>
                      </div>
                    </el-col>
                    <el-col :span="isPc? 3 : 8 "
                      v-show="nowActive.active == 2 && showMap">
                      <el-button
                        @click="tableEvent"
                        plain
                        :size="isPc?'medium':'mini'"
                        >表格统计</el-button>
                    </el-col>
                    <el-col :span="24"
                      v-if="nowActive.active == 1 && !showMap && !showBar" >
                      <div class="flex-right">
                        <el-button
                          @click="barEvent"
                          plain
                          :size="isPc?'medium':'mini'"
                        >柱状统计</el-button>
                        <el-button
                          @click="mapEvent"
                          plain
                          :size="isPc?'medium':'mini'"
                        >地图统计</el-button>
                        <el-button
                          @click="exportData"
                          plain
                          :size="isPc?'medium':'mini'"
                        >导出</el-button>
                      </div>
                    </el-col>
                    <el-col :span="24"
                      v-else-if="nowActive.active == 1 && showMap && !showBar">
                      <div class="flex-right">
                        <el-button
                          @click="barEvent"
                          plain
                          :size="isPc?'medium':'mini'"
                        >柱状统计</el-button>
                        <el-button
                          @click="tableEvent"
                          plain
                          :size="isPc?'medium':'mini'"
                          >表格统计</el-button>
                      </div>
                    </el-col>
                    <el-col :span="24"
                      v-else-if="nowActive.active == 1 && !showMap && showBar">
                      <div class="flex-right">
                        <el-button
                          @click="mapEvent"
                          plain
                          :size="isPc?'medium':'mini'"
                        >地图统计</el-button>
                        <el-button
                          @click="tableEvent"
                          plain
                          :size="isPc?'medium':'mini'"
                          >表格统计</el-button>
                      </div>
                    </el-col>
                    <el-col :span="24" v-if="nowActive.active == 12">
                      <div class="flex-right">
                        <el-button
                          @click="exportData"
                          plain
                          :size="isPc?'medium':'mini'"
                          >导出</el-button
                        >
                      </div>
                    </el-col>
                  </div>
                </el-row>
                <div class="caculate-area">
                  <div class="data-scroll-area">
                    <!-- 参与答题网名区域分布:2和各省市实际采集量:1表格 -->
                    <div class="total-table-2 total-table-3" style="overflow-x: auto;">
                      <el-table v-if="nowActive.active == 1 &&!showMap && !showBar"
                        v-loading="tableDataLoading"
                        element-loading-text="拼命加载中"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(0, 0, 0, 0.8)"
                        :data="provincesAndCitiesData"
                        :max-height="isPc?((screenHeight-50)>600?(screenHeight-50):'600'):'90000'"
                        style="width:100%;border: 1px solid #dcdfe6;"
                        :header-cell-style="{background:'#eceff6',color:'#444444',border:'1px solid #dcdfe6'}"
                        :cell-style="{border:'1px solid #dcdfe6'}"
                        row-key="id"
                        stripe
                        :fit="true"
                        ref="table"
                        lazy
                        :load="treePropsLoad"
                        :tree-props="{ children: 'children', hasChildren: 'isClick' }"
                        :border="!isPc"
                      >
                        <el-table-column label="序号" :min-width="isPc?'52':'36'" align="center">
                           <template slot-scope="scope">
                            <span>{{ scope.row.id | filterId(2) }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column label="区域" :min-width="isPc?'48':'40'" align="center">
                          <template slot-scope="scope">
                            <span v-if="!!scope.row.sourceList"
                              @click="clickRecommend(scope.row)"
                              :style="`color: ${theme.textColor}; text-decoration: underline;cursor:pointer;`"
                            >
                              {{ scope.row.name }}
                            </span>
                            <span v-else
                            >
                              {{ scope.row.name }}
                            </span>
                          </template>
                        </el-table-column>
                        <el-table-column label="合计" align="center">
                          <el-table-column prop="stageTotalAmount" :label="'总样本量'" :min-width="isPc?'68':'55'" align="center">
                          </el-table-column>
                        </el-table-column>
                        <el-table-column :label="'第一阶段样本采集量\n(7.22-7.31)'" align="center">
                          <el-table-column prop="firstStageTotalAmount" :label="'总样本量'" :min-width="isPc?'100':'62'" align="center">
                          </el-table-column>
                        </el-table-column>
                        <template v-if="isPc">
                          <el-table-column :label="'第二阶段样本采集量\n(8.1-8.15)'" align="center">
                            <el-table-column :label="'总样本量\n(主+专)'" align="center">
                              <el-table-column prop="totalAmount" :label="'合计'" min-width="58" align="center">
                              </el-table-column>
                              <el-table-column prop="totalPercentDesc" label="占比" min-width="64" align="center">
                              </el-table-column>
                            </el-table-column>
                            <el-table-column label="主问卷" align="center">
                              <el-table-column prop="amount" label="小计" min-width="58" align="center">
                              </el-table-column>
                              <el-table-column prop="publicAmount" label="公众版" min-width="58" align="center">
                              </el-table-column>
                              <el-table-column prop="employmentAmount" label="从业版" min-width="58" align="center">
                              </el-table-column>
                            </el-table-column>
                            <el-table-column label="专题问卷" align="center">
                              <el-table-column prop="specialAmount" label="小计" min-width="58" align="center">
                              </el-table-column>
                              <el-table-column prop="publicSpecialAmount" label="公众版" min-width="58" align="center">
                              </el-table-column>
                              <el-table-column prop="employmentSpecialAmount" label="从业版" min-width="58" align="center">
                              </el-table-column>
                            </el-table-column>
                          </el-table-column>
                        </template>
                        <template v-else>
                          <el-table-column :label="'第二阶段样本采集量\n(8.1-8.15)'" align="center">
                            <el-table-column label="总样本量" align="center">
                              <el-table-column prop="totalAmount" :label="'合计'" min-width="55" align="center">
                              </el-table-column>
                              <el-table-column prop="totalPercentDesc" label="占比" min-width="64" align="center">
                              </el-table-column>
                            </el-table-column>
                            <el-table-column prop="amount" :label="`主问卷\n(公+从)`" min-width="55" align="center">
                            </el-table-column>
                            <el-table-column prop="specialAmount" :label="`专题问卷\n(公+从)`" min-width="55" align="center">
                            </el-table-column>
                            <el-table-column prop="totalPublicAmount" :label="`公众版\n(主+专)`" min-width="54" align="center">
                            </el-table-column>
                            <el-table-column prop="totalEmployeeAmount" :label="`从业版\n(主+专)`" min-width="54" align="center">
                            </el-table-column>
                          </el-table-column>
                        </template>
                        <el-table-column label="操作" :min-width="isPc?'96':'45'" align="center" prop="">
                          <template slot-scope="scope" v-if="scope.row.name!='/'&&scope.row.name!='合计'">
                            <el-button v-if="scope.row.totalAmount>50" @click="createPlacard(scope.row, 4)" type="primary" size="mini">{{isPc?'生成喜报':'喜报'}}</el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                    <!-- 样本采集（汇总统计） -->
                    <div class="total-table-2"
                      v-if="(nowActive.active == 2 && areaActiveName==='first') &&!showMap"
                      style="overflow-x: auto;"
                    >
                      <el-table
                        v-loading="tableDataAreaLoading"
                        element-loading-text="拼命加载中"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(0, 0, 0, 0.8)"
                        :data="totalAreaData"
                        :max-height="isPc?((screenHeight-50)>600?(screenHeight-50):'600'):'90000'"
                        style="width:100%;border: 1px solid #dcdfe6;"
                        :header-cell-style="{background:'#eceff6',color:'#444444',border:'1px solid #dcdfe6'}"
                        :cell-style="{border:'1px solid #dcdfe6'}"
                        row-key="id"
                        stripe
                        :fit="true"
                        ref="area"
                        lazy
                        :load="treePropsLoad"
                        :tree-props="{ children: 'children', hasChildren: 'isClick'}"
                        :border="!isPc"
                        :row-class-name="tableRowClassName"
                        header-align="center"
                        :span-method="arraySpanMethod"
                      >
                        <el-table-column label="序号" :min-width="isPc?'60':'35'" align="center">
                          <template slot-scope="scope">
                            <span v-if="scope.row.id==0&&!isPc">全国</span>
                            <span v-else>{{ scope.row.id | filterId(1) }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column label="区域" :min-width="isPc?'60':'38'" align="center">
                          <template slot-scope="scope">
                            <span>
                              {{ scope.row.name }}
                            </span>
                          </template>
                        </el-table-column>
                        <el-table-column label="合计" align="center">
                          <el-table-column prop="stageTotalAmount" :label="'总样本量'" :min-width="isPc?'68':'55'" align="center">
                          </el-table-column>
                        </el-table-column>
                        <el-table-column align="center">
                          <template slot="header">
                            <div>第一阶段样本采集量</div>
                            <div>(7.22-7.31)</div>
                          </template>
                          <el-table-column prop="firstStageTotalAmount" :label="'总样本量'" :min-width="isPc?'90':'62'" align="center">
                          </el-table-column>
                        </el-table-column>
                        <el-table-column align="center">
                          <template slot="header">
                            <div>第二阶段样本采集量</div>
                            <div>(8.1-8.15)</div>
                          </template>
                          <el-table-column prop="totalAmount" label="总样本量" align="center" :min-width="isPc?'60':'55'">
                          </el-table-column>
                          <el-table-column prop="amount" label="主问卷总量 " align="center" :min-width="isPc?'60':'55'">
                          </el-table-column>
                          <el-table-column v-if="isPc" prop="percentDesc" label="总占比 " align="center" min-width="68">
                          </el-table-column>
                          <el-table-column prop="publicAmount" label="公众主问卷合计" align="center" :min-width="isPc?'60':'55'">
                          </el-table-column>
                          <el-table-column prop="employmentAmount" label="从业主问卷合计" align="center" :min-width="isPc?'60':'55'">
                          </el-table-column>
                          <el-table-column prop="specialAmount" label="专题问卷总量" align="center" :min-width="isPc?'60':'55'">
                          </el-table-column>
                        </el-table-column>
                        <el-table-column label="操作" :min-width="isPc?'96':'45'" align="center" prop="">
                          <template slot-scope="scope">
                            <el-button v-if="scope.row.totalAmount>1000" @click="createPlacard(scope.row, 2)" type="primary" size="mini">{{isPc?'生成喜报':'喜报'}}</el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                    <div v-show="showMap">
                      <div
                        id="mapContainer"
                        :style="isPc?'width:100%;height:1100px;':'width:700px;height: 700px;'"
                      ></div>
                    </div>
                    <div v-show="showBar">
                      <div id="barContainer" :style="isPc?'width:100%;height:1100px;':'width:600px;height: 700px;'"></div>
                    </div>
                    <!-- subject主问卷/专题采集量 （数量汇总） -->
                    <div class="total-table-2 total-table-3" style="overflow-x: auto;">
                      <el-table
                        v-if="(nowActive.active == 2 && areaActiveName==='second') &&!showMap"
                        v-loading="subjectLoading"
                        element-loading-text="拼命加载中"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(0, 0, 0, 0.8)"
                        :data="subjectTableData"
                        style="width:100%;border: 1px solid #dcdfe6;"
                        :header-cell-style="{background:'#eceff6',color:'#444444',border:'1px solid #dcdfe6'}"
                        :cell-style="{border:'1px solid #dcdfe6'}"
                        row-key="id"
                        stripe
                        :fit="true"
                        ref="subject"
                        lazy
                        :load="treePropsLoad"
                        :tree-props="{ children: 'children', hasChildren: 'isClick' }"
                        :border="true"
                        :row-class-name="tableRowClassName"
                      >
                        <el-table-column label="序号" :min-width="isPc?'60':'35'" align="center" fixed="left">
                          <template slot-scope="scope">
                            <span>{{ scope.row.id | filterId(1) }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column label="所属区域" min-width="60" align="center" fixed="left">
                          <template slot-scope="scope">
                            <span>
                              {{ scope.row.name }}
                            </span>
                          </template>
                        </el-table-column>
                        <el-table-column label="合计" align="center">
                          <el-table-column prop="stageTotalAmount" :label="'总样本量'" :min-width="isPc?'68':'55'" align="center">
                          </el-table-column>
                        </el-table-column>
                        <el-table-column :label="'第一阶段样本采集量\n(7.22-7.31)'" align="center">
                          <el-table-column prop="firstStageTotalAmount" :label="'总样本量'" :min-width="isPc?'90':'62'" align="center">
                          </el-table-column>
                        </el-table-column>
                        <el-table-column :label="'第二阶段样本采集量\n(8.1-8.15)'" align="center">
                          <el-table-column label="网民答题(主间卷、专题问卷)数量汇总" align="center">
                            <el-table-column prop="totalAmount" :label="'总样本量\n(A+B)'" align="center" min-width="60">
                            </el-table-column>
                            <el-table-column :label="'主问卷量\n(A1+B1)'" prop="amount" min-width="60" align="center">
                            </el-table-column>
                            <el-table-column :label="'专题问卷量\n(A2+B2)'" prop="specialAmount" min-width="60" align="center">
                            </el-table-column>
                            <el-table-column :label="'公众网民版\nA'" align="center">
                              <el-table-column :label="'主问卷\n小计\nA1'" prop="publicAmount" min-width="70" align="center">
                              </el-table-column>
                              <el-table-column :label="'专题问卷\nA2'" align="center">
                                <el-table-column :label="'专题问卷\n小计\nA2'" prop="publicSpecialAmount" width="75" align="center">
                                </el-table-column>
                                <el-table-column :label="'网络安全法治社会建设\nA21'" prop="publicSpecial1Amount" width="65" align="center">
                                </el-table-column>
                                <el-table-column :label="'网络诚信建设\nA22'" prop="publicSpecial2Amount" width="65" align="center">
                                </el-table-column>
                                <el-table-column :label="'遏制惩处网络违法犯罪行为\nA23'" prop="publicSpecial3Amount" width="70" align="center">
                                </el-table-column>
                                <el-table-column :label="'个人信息保护和数据安全\nA24'" prop="publicSpecial4Amount" width="70" align="center">
                                </el-table-column>
                                <el-table-column :label="'网络购物权益保护\nA25'" prop="publicSpecial5Amount" width="70" align="center">
                                </el-table-column>
                                <el-table-column :label="'特殊人群（未成年人和老人等）网络权益保护\nA26'" prop="publicSpecial6Amount" width="70" align="center">
                                </el-table-column>
                                <el-table-column :label="'互联网平台监管与企业自律\nA27'" prop="publicSpecial7Amount" width="70" align="center">
                                </el-table-column>
                                <el-table-column :label="'数字政府服务与治理能力提升\nA28'" prop="publicSpecial8Amount" width="70" align="center">
                                </el-table-column>
                                <el-table-column :label="'智能社会发展与治理挑战\nA29'" prop="publicSpecial9Amount" min-width="70" align="center">
                                </el-table-column>
                                <el-table-column :label="'中国网民权益保护'" prop="publicSpecial10Amount" min-width="70" align="center">
                                </el-table-column>
                              </el-table-column>
                            </el-table-column>
                            <el-table-column :label="'从业人员版\nB'" align="center">
                              <el-table-column :label="'主问卷\n小计\nB1'" prop="employmentAmount" min-width="70" align="center">
                              </el-table-column>
                              <el-table-column :label="'专题问卷\nB2'" align="center">
                                <el-table-column :label="'专题问卷\n小计\nB2'" prop="employmentSpecialAmount" min-width="75" align="center">
                                </el-table-column>
                                <el-table-column :label="'行业治理与企业合规\nB21'" prop="employmentSpecialAAmount" min-width="65" align="center">
                                </el-table-column>
                                <el-table-column :label="'行业发展与科技创新\nB22'" prop="employmentSpecialBAmount" min-width="65" align="center">
                                </el-table-column>
                                <el-table-column :label="'新技术挑战与网络安全\nB23'" prop="employmentSpecialCAmount" min-width="65" align="center">
                                </el-table-column>
                              </el-table-column>
                            </el-table-column>
                          </el-table-column>
                        </el-table-column>
                      </el-table>
                    </div>
                    <!-- 发起、推荐单位采集量 -->
                    <div class="total-table-2 total-table-3" v-if="nowActive.active == 5" style="overflow-x: auto;">
                      <com-table
                        :showTable="nowActive.active == 5"
                        :type="2"
                        :tableLoading="recommendTableDataLoading"
                        :isPc="isPc"
                        :tableRef="`unit${unitActiveName}Ref`"
                        :tableData="(unitActiveName==='second'?recommendTableData:(unitActiveName==='three'?jointTableData:initiateTableData))"
                        :title="unitActiveName === 'second'? '推荐单位': (unitActiveName === 'three'?'联合发起单位':'发起单位')"
                        :textColor="theme.textColor"
                        :screenHeight="screenHeight"
                        @clickRecommend="clickRecommend"
                        @createPlacard="createPlacard"
                      ></com-table>
                    </div>
                    <!-- 各链接采集量 -->
                    <div v-if="nowActive.active == 6" class="total-table-2 total-table-3">
                      <div class="tips-6">只列出总样本量20以上的来源，请输入来源名称或ID精准搜索</div>
                      <el-table
                        ref="thePublic"
                        v-loading="thePublicLoading"
                        element-loading-text="拼命加载中"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(0, 0, 0, 0.8)"
                        :data="loadedCollectBaseList"
                        v-infinite-scroll="loadMore"
                        infinite-scroll-disabled="busy"
                        :header-cell-style="{background:'#eceff6',color:'#444444',border:'1px solid #dcdfe6'}"
                        :cell-style="{border:'1px solid #dcdfe6'}"
                        key="thePublic"
                        :max-height="isPc?((screenHeight-50)>600?(screenHeight-50):'600'):'90000'"
                        style="border: 1px solid #dcdfe6;overflow-y: auto;"
                        stripe
                        :fit="true"
                        :border="!isPc"
                        :row-class-name="tableRowClassName"
                      >
                        <el-table-column label="序号" :width="isPc?'55':'32'" align="center" fixed="left">
                          <template slot-scope="scope">
                            <span>{{ scope.$index || '' }}</span>
                          </template>
                        </el-table-column>
                        <template v-if="isPc">
                          <el-table-column prop="province" :label="isPc?'所属区域':'区域'" :min-width="isPc?'50':'40'" align="center">
                          </el-table-column>
                          <el-table-column prop="city" :label="isPc?'城市':'市'" :min-width="isPc?'50':'35'" align="center">
                          </el-table-column>
                          <el-table-column prop="category" label="分类" :min-width="isPc?'60':'55'" align="center">
                          </el-table-column>
                          <el-table-column prop="associatedName" label="所属名称" :min-width="isPc?'':'50'" align="center">
                          </el-table-column>
                        </template>
                        <el-table-column prop="sourceName":label="'来源渠道\n(ID)'" :min-width="isPc?'':'55'" align="center" :fixed="!isPc">
                          <template slot-scope="scope">
                            <div>
                              {{ scope.row.sourceName }}{{ scope.row.sourceId?`(${scope.row.sourceId})`:'' }}
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column label="合计" align="center">
                          <el-table-column prop="stageTotalAmount" :label="'总样本量'" :min-width="isPc?'68':'55'" align="center">
                          </el-table-column>
                        </el-table-column>
                        <el-table-column :label="'第一阶段样本采集量\n(7.22-7.31)'" align="center">
                          <el-table-column prop="firstStageTotalAmount" :label="'总样本量'" :min-width="isPc?'100':'62'" align="center">
                          </el-table-column>
                        </el-table-column>
                        <el-table-column :label="'第二阶段样本采集量\n(8.1-8.15)'" align="center">
                          <el-table-column prop="totalAmount" :label="'总样本量\n(X+Y)'" :min-width="isPc?'60':'55'" align="center">
                          </el-table-column>
                          <el-table-column label="主问卷采集量" align="center" :min-width="isPc?'60':'55'">
                            <el-table-column prop="amount" :label="'小计(X)'" :min-width="isPc?'60':'55'" align="center">
                            </el-table-column>
                            <el-table-column prop="publicAmount" label="公众版" :min-width="isPc?'60':'55'" align="center">
                            </el-table-column>
                            <el-table-column prop="employmentAmount" label="从业版" :min-width="isPc?'60':'55'" align="center">
                            </el-table-column>
                          </el-table-column>
                          <el-table-column prop="specialAmount" :label="'专题问卷采集量\n(Y)'" :min-width="isPc?'60':'55'" align="center">
                          </el-table-column>
                        </el-table-column>
                        <el-table-column label="操作" :min-width="isPc?'96':'58'" align="center" prop="">
                          <template slot-scope="scope">
                            <div><el-button v-if="scope.row.sourceName!='合计'&&(scope.row.totalAmount>50)" @click="createPlacard(scope.row, 1)" type="primary" size="mini">{{isPc?'生成喜报':'喜报'}}</el-button></div>
                            <!-- 推荐单位链接需要放开 -->
                            <!-- <el-button v-else-if="scope.row.sourceName==='合计'" @click="getPlacardInfo(scope.row)" type="warning" size="mini">{{isPc?'生成喜报':'喜报'}}</el-button> -->
                            <div style="margin-top: 5px;"><el-button v-if="!!scope.row.sourceId" @click="checkInvitationData(scope.row.sourceId)" type="primary" size="mini">已邀数量</el-button></div>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                    <!-- 志愿服务 -->
                    <div class="total-table-2 total-table-3" v-if="nowActive.active == 8" style="overflow-x: auto;">
                      <com-table
                        :showTable="nowActive.active == 8"
                        :type="1"
                        :tableLoading="volunteerLoading"
                        :isPc="isPc"
                        :tableRef="`volunteer${volunteerActiveName}Ref`"
                        :tableData="volunteerTabTableData"
                        :title="volunteerActiveName === 'second'?'志愿服务队':(volunteerActiveName === 'three'?'志愿者':(volunteerActiveName === 'four'?'其他志愿团体':(volunteerActiveName === 'five'?'公益讲师':'志愿服务站')))"
                        :textColor="theme.textColor"
                        :screenHeight="screenHeight"
                        @clickRecommend="clickRecommend"
                        @createPlacard="createPlacard"
                      ></com-table>
                    </div>
                    <!-- 喜报墙 -->
                    <div v-show="nowActive.active == 10">
                      <div class="content-box-title"> {{ nowPosterData.title }} </div>
                      <el-row>
                        <template v-for="(item,index) in nowPosterData.topList" >
                          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" v-if="item.topData.length>0">
                            <wall :title="item.name" :type="nowPosterData.title" :dataList="item.topData" :tabbt="theme.tabbt" :isPc="isPc" @onClick="createPlacard" ></wall>
                          </el-col>
                        </template>
                      </el-row>
                    </div>
                    <div class="total-table-2 total-table-3" v-show="nowActive.active == 11" style="overflow-x: auto;">
                      <com-table
                        :showTable="nowActive.active == 11"
                        :type="UniversityActiveName==='first'?1 : 2"
                        :tableLoading="schoolLoading"
                        :isPc="isPc"
                        :tableData="schoolTableData"
                        tableRef="schoolTableRef"
                        :title="UniversityActiveName==='first'?'高校':'区域'"
                        :textColor="theme.textColor"
                        :screenHeight="screenHeight"
                        @clickRecommend="clickRecommend"
                        @createPlacard="createPlacard"
                      ></com-table>
                    </div>
                    <div class="total-table-2 total-table-3" v-show="nowActive.active == 12" style="overflow-x: auto;">
                      <tesidence-table
                        :showTable="nowActive.active == 12"
                        :type="1"
                        :tableLoading="tesidenceLoading"
                        :isPc="isPc"
                        :tableData="tesidenceTableData"
                        tableRef="tesidenceTableRef"
                        title="常住地"
                        :textColor="theme.textColor"
                        :screenHeight="screenHeight"
                        @clickRecommend="clickRecommend"
                        @createPlacard="createPlacard"
                      ></tesidence-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <!-- 全国企业采集量、共用弹窗 -->
    <el-dialog
      :title="dialogRecommendTitle"
      :visible.sync="dialogRecommendTable"
      center
      :width="isPc?'90%':'95%'"
      class="dialog-container"
      top="5vh"
    >
      <div class="dialog-box total-table-2">
        <el-table
          v-if="dialogRecommendTable"
          v-loading="dialogRecommendLoading"
          :data="dialogRecommendData"
          :header-cell-style="{background:'#eceff6',color:'#444444',border:'1px solid #dcdfe6'}"
          :cell-style="{border:'1px solid #dcdfe6'}"
          style="border: 1px solid #dcdfe6;"
          :max-height="(screenHeight-100)>600?(screenHeight-100):'600'"
          stripe
          :row-class-name="tableRowClassName"
          header-align="center"
        >
          <el-table-column type="index" label="序号" :min-width="isPc?'50':'35'" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index===0?' ':scope.$index }}</span>
            </template>
          </el-table-column>
          <el-table-column label="省" :min-width="isPc?'50':'35'" align="center">
						<template slot-scope="scope">
              <div> {{ scope.row.province }} </div>
            </template>
					</el-table-column>
          <el-table-column v-if="isPc" label="城市" :min-width="isPc?'50':'40'" align="center">
						<template slot-scope="scope">
              <div> {{ scope.row.city }} </div>
            </template>
					</el-table-column>
          <el-table-column v-if="isPc" prop="category" label="分类" :min-width="isPc?'60':'35'" align="center"> </el-table-column>
          <template v-if="nowActive.active ===1&&isWord">
            <el-table-column prop="associatedName" label="所属名称" :min-width="isPc?'100':'60'" align="center">
            </el-table-column>
          </template>
          <template v-else>
            <el-table-column prop="sourceName" label="来源渠道" :min-width="isPc?'100':'60'" align="center">
            </el-table-column>
          </template>
          <el-table-column label="合计" align="center">
            <el-table-column prop="stageTotalAmount" :label="'总样本量'" :min-width="isPc?'68':'55'" align="center">
            </el-table-column>
          </el-table-column>
          <el-table-column align="center">
            <template slot="header">
              <div>第一阶段样本采集量</div>
              <div>(7.22-7.31)</div>
            </template>
            <el-table-column prop="firstStageTotalAmount" :label="'总样本量'" :min-width="isPc?'90':'60'" align="center">
            </el-table-column>
          </el-table-column>
          <el-table-column align="center">
              <template slot="header">
                <div>第二阶段样本采集量</div>
                <div>(8.1-8.15)</div>
              </template>
            <template v-if="nowActive.active ===1">
              <template v-if="isWord">
                <el-table-column prop="totalAmount" :min-width="isPc?'80':'55'" align="center">
                  <template slot="header">
                    <div>总样本量</div>
                    <div>(主+专)</div>
                  </template>
                </el-table-column>
                <el-table-column label="主问卷" align="center">
                  <el-table-column label="小计" :min-width="isPc?'60':'55'" align="center">
                    <template slot-scope="scope">
                      <div>
                        {{ scope.row.amount }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="publicAmount" label="公众版" :min-width="isPc?'60':'55'" align="center">
                  </el-table-column>
                  <el-table-column prop="employmentAmount" label="从业版" :min-width="isPc?'60':'55'" align="center">
                  </el-table-column>
                </el-table-column>
                <el-table-column prop="specialAmount" label="专题问卷" :min-width="isPc?'60':'55'" align="center">
                </el-table-column>
              </template>
              <template v-else-if="isPc">
                <el-table-column align="center">
                  <template slot="header">
                    <div>总样本量</div>
                    <div>(主+专)</div>
                  </template>
                  <el-table-column prop="totalAmount" :label="'合计'" min-width="60" align="center">
                  </el-table-column>
                  <el-table-column prop="totalPercentDesc" label="占比" min-width="68" align="center">
                  </el-table-column>
                </el-table-column>
                <el-table-column label="主问卷" align="center">
                  <el-table-column prop="amount" label="小计" min-width="60" align="center">
                  </el-table-column>
                  <el-table-column prop="publicAmount" label="公众版" min-width="60" align="center">
                  </el-table-column>
                  <el-table-column prop="employmentAmount" label="从业版" min-width="60" align="center">
                  </el-table-column>
                </el-table-column>
                <el-table-column label="专题问卷" align="center">
                  <el-table-column prop="specialAmount" label="小计" min-width="60" align="center">
                  </el-table-column>
                  <el-table-column prop="publicSpecialAmount" label="公众版" min-width="60" align="center">
                  </el-table-column>
                  <el-table-column prop="employmentSpecialAmount" label="从业版" min-width="60" align="center">
                  </el-table-column>
                </el-table-column>
              </template>
              <template v-else>
                <el-table-column label="总样本量" align="center">
                  <el-table-column prop="totalAmount" :label="'合计'" :min-width="isPc?'60':'55'" align="center">
                  </el-table-column>
                  <el-table-column prop="totalPercentDesc" label="占比" :min-width="isPc?'68':'52'" align="center">
                  </el-table-column>
                </el-table-column>
                <el-table-column prop="amount" :min-width="isPc?'60':'55'" align="center">
                  <template slot="header">
                    <div>主问卷</div>
                    <div>(公+从)</div>
                  </template>
                </el-table-column>
                <el-table-column prop="specialAmount" :min-width="isPc?'60':'55'" align="center">
                  <template slot="header">
                    <div>专题问卷</div>
                    <div>(公+从)</div>
                  </template>
                </el-table-column>
                <el-table-column prop="totalPublicAmount" :min-width="isPc?'60':'54'" align="center">
                  <template slot="header">
                    <div>公众版</div>
                    <div>(主+专)</div>
                  </template>
                </el-table-column>
                <el-table-column prop="totalEmployeeAmount" :min-width="isPc?'60':'54'" align="center">
                  <template slot="header">
                    <div>从业版</div>
                    <div>(主+专)</div>
                  </template>
                </el-table-column>
              </template>
            </template>
            <template v-else>
              <el-table-column prop="totalAmount" :min-width="isPc?'60':'60'" align="center">
                <template slot="header">
                  <div>总样本量</div>
                  <div>(X+Y)</div>
                </template>
              </el-table-column>
              <el-table-column label="主问卷采集量" align="center">
                <el-table-column prop="amount" label="小计(X)" :min-width="isPc?'60':'60'" align="center">
                </el-table-column>
                <el-table-column prop="publicAmount" label="公众版" :min-width="isPc?'60':'60'" align="center">
                </el-table-column>
                <el-table-column prop="employmentAmount" label="从业版" :min-width="isPc?'60':'60'" align="center">
                </el-table-column>
              </el-table-column>
              <el-table-column prop="specialAmount" :min-width="isPc?'60':'60'" align="center">
                <template slot="header">
                  <div>专题问卷采集量</div>
                  <div>(Y)</div>
                </template>
              </el-table-column>
            </template>
          </el-table-column>
          <el-table-column label="操作" :width="isPc?'':'45'" align="center" prop="">
            <template slot-scope="scope" v-if="scope.row.name!='/'&&scope.row.name!='合计'">
              <el-button v-if="nowActive.active ===11&&scope.row.totalAmount>50" @click="createPlacard(scope.row, 5)" type="primary" size="mini">{{isPc?'生成喜报':'喜报'}}</el-button>
              <el-button v-else-if="scope.row.totalAmount>50" @click="createPlacard(scope.row, 1)" type="primary" size="mini">{{isPc?'生成喜报':'喜报'}}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!-- dialogcityTopLoading 各省市列 城市top100 -->
    <el-dialog
      title="城市Top100"
      :visible.sync="dialogcityTop"
      center
      :width="isPc?'80%':'95%'"
      class="dialog-container"
      top="5vh"
    >
      <div class="dialog-box">
        <el-table
          v-loading="dialogcityTopLoading"
          :data="cityTableDataTop100"
          :header-cell-style="{background:'#eceff6',color:'#444444',border:'1px solid #dcdfe6'}"
          :cell-style="{border:'1px solid #dcdfe6'}"
          style="border: 1px solid #dcdfe6;"
          :max-height="(screenHeight-100)>600?(screenHeight-100):'600'"
          stripe
        >
        <!-- 序号，城市，所属省，总数，公众，从业 -->
          <el-table-column type="index" label="序号" :min-width="isPc?'60':'35'" align="center">
          </el-table-column>
          <el-table-column label="城市" :min-width="isPc?'60':'35'" align="center">
						<template slot-scope="scope">
              <div> {{ scope.row.city.replace(/市$/, '') }} </div>
            </template>
					</el-table-column>
          <el-table-column label="所属省" :min-width="isPc?'60':'35'" align="center">
						<template slot-scope="scope">
              <div> {{ scope.row.province }} </div>
            </template>
					</el-table-column>
          <el-table-column label="合计" align="center">
            <el-table-column prop="stageTotalAmount" :label="'总样本量'" :min-width="isPc?'68':'55'" align="center">
            </el-table-column>
          </el-table-column>
          <el-table-column align="center">
            <template slot="header">
              <div>第一阶段样本采集量</div>
              <div>(7.22-7.31)</div>
            </template>
            <el-table-column prop="firstStageTotalAmount" :label="'总样本量'" :min-width="isPc?'90':'62'" align="center">
            </el-table-column>
          </el-table-column>
          <el-table-column align="center">
            <template slot="header">
              <div>第二阶段样本采集量</div>
              <div>(8.1-8.15)</div>
            </template>
            <el-table-column prop="totalAmount" :min-width="isPc?'60':'60'" align="center">
              <template slot="header">
                <div>总样本量</div>
                <div>(X+Y)</div>
              </template>
            </el-table-column>
            <el-table-column label="主问卷采集量" align="center">
              <el-table-column prop="amount" label="小计(X)" :min-width="isPc?'60':'60'" align="center">
              </el-table-column>
              <el-table-column prop="publicAmount" label="公众版" :min-width="isPc?'60':'60'" align="center">
              </el-table-column>
              <el-table-column prop="employmentAmount" label="从业版" :min-width="isPc?'60':'60'" align="center">
              </el-table-column>
            </el-table-column>
            <el-table-column prop="specialAmount" :min-width="isPc?'60':'60'" align="center">
              <template slot="header">
                <div>专题问卷采集量</div>
                <div>(Y)</div>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!-- 网民列城市Top100 -->
    <el-dialog
      title="城市Top100"
      :visible.sync="dialogAreaCityTop"
      center
      :width="isPc?'80%':'95%'"
      class="dialog-container"
      top="5vh"
    >
      <div class="dialog-box">
        <el-table
          v-loading="dialogAreaCityTopLoading"
          :data="areaCityTableDataTop100"
          :header-cell-style="{background:'#eceff6',color:'#444444',border:'1px solid #dcdfe6'}"
          :cell-style="{border:'1px solid #dcdfe6'}"
          style="border: 1px solid #dcdfe6;"
          :max-height="(screenHeight-100)>600?(screenHeight-100):'600'"
          stripe
        >
        <!-- 序号，城市，所属省，总数，公众，从业 -->
          <el-table-column type="index" label="序号" :min-width="isPc?'60':'35'" align="center">
          </el-table-column>
          <el-table-column label="城市" :min-width="isPc?'60':'35'" align="center">
						<template slot-scope="scope">
              <div> {{ scope.row.city }} </div>
            </template>
					</el-table-column>
          <el-table-column label="所属省" :min-width="isPc?'60':'35'" align="center">
						<template slot-scope="scope">
              <div> {{ scope.row.province }} </div>
            </template>
					</el-table-column>
          <el-table-column label="合计" align="center">
            <el-table-column prop="stageTotalAmount" :label="'总样本量'" :min-width="isPc?'68':'55'" align="center">
            </el-table-column>
          </el-table-column>
          <el-table-column align="center">
            <template slot="header">
              <div>第一阶段样本采集量</div>
              <div>(7.22-7.31)</div>
            </template>
            <el-table-column prop="firstStageTotalAmount" :label="'总样本量'" :min-width="isPc?'90':'62'" align="center">
            </el-table-column>
          </el-table-column>
          <el-table-column align="center">
            <template slot="header">
              <div>第二阶段样本采集量</div>
              <div>(8.1-8.15)</div>
            </template>
            <el-table-column prop="totalAmount" :min-width="isPc?'60':'60'" align="center">
              <template slot="header">
                <div>总样本量</div>
                <div>(X+Y)</div>
              </template>
            </el-table-column>
            <el-table-column label="主问卷采集量" align="center">
              <el-table-column prop="amount" label="小计(X)" :min-width="isPc?'60':'60'" align="center">
              </el-table-column>
              <el-table-column prop="publicAmount" label="公众版" :min-width="isPc?'60':'60'" align="center">
              </el-table-column>
              <el-table-column prop="employmentAmount" label="从业版" :min-width="isPc?'60':'60'" align="center">
              </el-table-column>
            </el-table-column>
            <el-table-column prop="specialAmount" :min-width="isPc?'60':'60'" align="center">
              <template slot="header">
                <div>专题问卷采集量</div>
                <div>(Y)</div>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
		<el-dialog
      :visible.sync="showIframe"
      center
			:width="isPc?'450px':'100%'"
      top="5vh"
      class="dialog-top"
    >
			<div v-if="showIframe && showWorldTop" class="iframe-box">
        <my-top :dataList="provincesAndCitiesTop" :time="updateTime"></my-top>
			</div>
      <div v-if="showIframe && showFirmTop" class="iframe-box">
        <firm-top :dataList="companyTop" :time="updateTime"></firm-top>
			</div>
      <div v-if="showIframe && showEducationTop" class="iframe-box">
        <education-top :dataList="educationTop" :time="updateTime"></education-top>
			</div>
		</el-dialog>
    <el-dialog
      :visible.sync="showPoster"
      title="喜报"
      center
      top="5vh"
      :width="isPc?'600px':'380px'"
      class="dialog-Poster"
    >
      <div style="height: 100%;">
        <el-carousel arrow="always" trigger="click" :autoplay="false" :height="isPc?'1060px':`${1060*0.62}px`" indicator-position="none">
          <template v-if="posterData.type === 1">
            <el-carousel-item v-for="item in 5" :key="item">
              <!-- 爱心喜报 -->
              <div style="display: flex;justify-content: center;">
                <poster :isPc="isPc" :active="nowActive.active" :type="item" :rowData="posterData.rowData" :name="posterData.name" :time="updateTime"></poster>
              </div>
            </el-carousel-item>
          </template>
          <template v-if="posterData.type === 2">
            <el-carousel-item v-for="item in 5" :key="item">
              <div style="display: flex;justify-content: center;">
                <poster-s :isPc="isPc" :type="item" :rowData="posterData.rowData" :totalAmount="posterData.totalAmount" :name="posterData.name" :time="updateTime"></poster-s>
              </div>
              </el-carousel-item>
          </template>
          <template v-if="posterData.type === 3">
            <el-carousel-item v-for="item in 5" :key="item">
              <div style="display: flex;justify-content: center;">
                <poster-s :isPc="isPc" :type="item" :rowData="posterData.rowData" :totalAmount="posterData.totalAmount" :name="posterData.name" :time="posterData.rowData.time"></poster-s>
              </div>
              </el-carousel-item>
          </template>
        </el-carousel>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="showPlacardInfoDialog"
      title="全国喜报配置"
      center
      top="5vh"
      :width="isPc?'600px':'95%'"
      class="dialog-container"
    >
      <placard-info @submit="submitFrom"></placard-info>
    </el-dialog>
    <el-dialog
      title="已邀数量"
      :visible.sync="dialogInvitation"
      center
      :width="isPc?'80%':'95%'"
      class="dialog-container"
      top="5vh"
    >
      <div class="dialog-box">
        <invitation-table
          :showTable="dialogInvitation"
          :type="1"
          :tableLoading="dialogInvitationLoading"
          :isPc="isPc"
          :tableData="invitationData"
          tableRef="invitationTableRef"
          title="已邀数量"
          :textColor="theme.textColor"
          :screenHeight="screenHeight"
        ></invitation-table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from 'axios'
import * as echarts from 'echarts'
import geojson from './geojson.json' // 无省市后缀
import MyTop from './top.vue';
import FirmTop from './firmTop.vue';
import EducationTop from './educationTop.vue';
import poster from './poster.vue';
import posterS from './posterS.vue';
import wall from './wall.vue';
import placardInfo from './placardInfo.vue';
import { activeTab, isWeChatAndroid, isBlobDownloadSupported, addSuffix } from '../utils/index.js';
import ComTable from './table/ComTable.vue';
import TesidenceTable from './table/TesidenceTable.vue';
import InvitationTable from './table/InvitationTable.vue';

// 创建一个axios实例
const apiInstance = axios.create({
  baseURL: 'https://myd-api.iscn.org.cn',
  // baseURL: 'https://myd-test.iscn.org.cn',
  // headers: {
  //   'Content-Type': 'application/json'
  // },
});
var myChart;
export default {
  name: 'Home',
  components: {
    'my-top': MyTop,
    'firm-top': FirmTop,
    'education-top': EducationTop,
    'poster': poster,
    'poster-s': posterS,
    'wall': wall,
    'placard-info': placardInfo,
    'com-table': ComTable,
    'tesidence-table': TesidenceTable,
    'invitation-table': InvitationTable,
  },
  data() {
    return {
      urlBase: '/tduck-api', // 接口公共前缀
      // urlBase: '/tduck-api-test', // 测试接口公共前缀
      showPoster: false,
      showPlacardInfoDialog: false,
      posterData: {
        type: 1,
        name: '',
        rowData: {},
        totalAmount: 0,
        specialAmount: 0,
      },
      geojsonData: {},
      theme: {
        isRed: false,
        bg: 'bg2025_v2.png',
        bgColor: "#977EFE",
        themeColor: "#595FC0",
        otherBgColor: "#EA3E14",
        lableBg: 'lable2025_2.png',
        tabbt: 'tabbt2025_2.png',
        tabsBg: 'custom-tabs-no-red',
        textColor: 'blue'
      },
      year: 2025,
      apiStr: '2025/v2',
      // 菜单
      activeTab: activeTab,
      nowActive: {},
			tableKey: 2,
      totalAreaData: [], //参与答题网民区域分布
      provincesAndCitiesData: [], // 各省市实际采集量
      collectBaseList: [], // 所有数据采集量数据公众
      loadedCollectBaseList: [],    // 已加载的数据
      chunkSize: 50,     // 每次加载条数
      busy: false,
      recommendTableData: [], //推荐单位采集量表格数据
      initiateTableData: [], //发起单位
      jointTableData: [], //联合发起单位
      volunteerTabTableData: [], // 志愿服务数据
      volunteerTableData: [], // 志愿者
      subjectTableData: [], // 主问卷/专题采集量 （数量汇总）
      schoolTableData: [], // 高校数据
      tesidenceTableData: [], //  常住地数据
      sortList: [], //分类数据
      recommendTableDataLoading: false,
      volunteerLoading: false,
      tableDataLoading: false,
      tableDataAreaLoading: false,
      thePublicLoading: false,
      subjectLoading: false,
      schoolLoading: false,
      tesidenceLoading: false,
      loading: false,
      // 服务站：volunteerOrgName
      // 服务队：volunteerUnitName
      // 志愿者：sourceName
      toolData: {
        category: '',
        sourceName: '',
        sourceId: '',
        province: '',
        recommended: '',
        volunteerOrgName: '',
        volunteerUnitName: '',
        city: '',
        university: '',
      },
      provinceList: [],
      cityList: [],
      //对话框
      dialogRecommendTable: false,
      dialogRecommendTitle: '',
      dialogRecommendData: [],
      dialogRecommendLoading: false,
      showMap: false, //地图
      dealMapData: [],
      showBar: false, //柱状图
      dealBarData: [],
			showIframe: false,
			showWorldTop: false, // 全国前十
			showFirmTop: false, // 企业前十
			showEducationTop: false, // 教育前十
			isCity: false,
			updateTime: "",
      posterActiveName: 'first',
      volunteerActiveName: 'first',
      areaActiveName: 'first',
      unitActiveName: 'first',
      UniversityActiveName: 'first',
      screenWidth: document.body.clientWidth,
      screenHeight: document.body.clientHeight,
      tableWidth: 'width:100%',
      isPc: true,
      provincesAndCitiesTop: [],
      companyTop: [],
      educationTop: [],
      firmList: [], // 企业采集量
      cityTableDataTop100: [], // 城市列表
      dialogcityTop: false,
      dialogcityTopLoading: false,
      invitationData: [],
      dialogInvitation: false,
      dialogInvitationLoading: false, // 邀请码
      areaCityTableDataTop100: [], // 城市列表
      dialogAreaCityTop: false,
      dialogAreaCityTopLoading: false,
      nowPosterData: {
        id: null,
        identification: '',
        title: "",
        parentId: null,
        topList: []
      },
      isWord: false,
    };
  },
  created() {
    this.nowActive = this.activeTab[0], // 默认选中数组第一个tab
		this.geojsonData = geojson; // 获取地图
    this.func_get_sort(); // 获取分类成功后，再获取当前tab的数据
  },
  mounted() {
    // 这是在获取当前屏幕的数据
    const that = this;
    window.onresize = ()=> {
      return (()=> {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
        window.screenHeight = document.body.clientHeight;
        that.screenHeight = window.screenHeight;
      })()
    }
  },
  watch: {
    screenWidth: {
      immediate: true,
      handler: function (newVal) {
        if(newVal>768) {
          this.isPc = true;
        }else {
          this.isPc = false;
        }
      }
    }
  },
	updated() {
  },
  beforeUnmount() {
  },
  filters: {
    filterId: function (value, type) {
      let count = 0;
      for (let i = 0; i < value.length; i++) {
        if (value.charAt(i) === '-') {
          count++;
        }
      }
      if(count===0) {
        return Number(value)?value:' '
      }else if ( type === 2 && count===1 ) {
        let ary = value.split('-')
        return `(${ary[count]})`
      }else if ( type === 2 && count===2 ) {
        let ary = value.split('-')
        return `[${ary[count]}]`
      }else {
        return ' '
      }
    },
  },
  methods: {
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if(rowIndex === 0&&!this.isPc) {
        if (columnIndex === 1) {
          return [0, 0];
        } else if (columnIndex === 2) {
          return [1, 2];
        }
      }
    },
    filterActive: function ( tab ) {
      let obj = this.activeTab.find(item=>item.active === this.nowActive.active);
      let tabObj = obj.children.find(item=>item.identification === tab);
      return !!tabObj.title?tabObj.title: ''
    },
    getPlacardInfo() {
      this.showPlacardInfoDialog = true;
    },
    submitFrom(info) {
      this.createPlacard(info, 3)
    },
    createPlacard(row, type) {
      this.showPoster = false;
      this.loading = true;
      if(!!this.updateTime) {
        console.log('this.isWord', this.isWord)
        if(type === 1) { // 服务队/个人喜报
          let title = this.isWord&&this.nowActive.active===1?row.associatedName:row.name;
          this.posterData = {
            type: 1,
            name: title,
            rowData: row,
          }
        }else if(type === 2) { // 网民喜报
          let title = row.name;
          if(row.name === '合计') {
            title = '全国';
          }
          this.posterData = {
            type: 2,
            name: title,
            rowData: row,
            totalAmount: row.totalAmount,
          }
        }else if(type === 3) {
          this.posterData = {
            type: 3,
            name: row.name,
            rowData: row,
            totalAmount: row.totalAmount,
          }
        }else if(type === 4) { // 各省市
          let title = addSuffix(row.name);
          this.posterData = {
            type: 1,
            name: title,
            rowData: row,
          }
        }else if(type === 5) { // 高校，取stageTotalAmount
          let title = row.name;
          this.posterData = {
            type: 1,
            name: title,
            rowData: {
              totalAmount: row.totalAmount,
              amount: row.firstStageAmount+row.amount, // 主问卷总量
              specialAmount: row.firstStageSpecialAmount+row.specialAmount, // 主问卷总量
              firstStageTotalAmount: row.firstStageTotalAmount, // 第一阶段总量
              stageTotalAmount: row.stageTotalAmount, // 样本总量
            },
          }
        }

        this.showPoster = true;
        this.$nextTick(()=>{
          setTimeout(()=>{
            this.loading = false;
          }, 1000)
        });
      }

    },
    checkInvitationData(sourceId) {
      this.invitationData = [];
      this.dialogInvitation = false;
      this.loading = true;
      this.dialogInvitationLoading = true;
      // 获取城市top100
      apiInstance.post(`${this.urlBase}/myd/count/${this.apiStr}/invitationalSourceCount`, {
        parentId: sourceId
      }).then(res => {
        let { data } = res;
        this.dialogInvitation = true;
        // 更新缓存时间
        // if(!!data.data.cacheDeadLineDesc) {
        //   this.updateTime = data.data.cacheDeadLineDesc;
        // }
        // 初始化数据容器
        if(!!data.data.childrenList) {
          this.invitationData = data.data.childrenList
          console.log('this.invitationData',this.invitationData)
        }
        this.dialogInvitationLoading = false;
        this.loading = false;
      }).catch( error => {
        this.dialogInvitationLoading = false;
        this.loading = false;
        this.$message.error('出错了，请联系工作人员！');
      });
    },
    clickDropdownMenu(command) {
      console.log("command",command);
      let active = command.parentId;
      this.toolData = {
        category: '',
        sourceName: '',
        sourceId: '',
        province: '',
        recommended: '',
        volunteerOrgName: '',
        volunteerUnitName: '',
        city: '',
        university: ''
      };
      if (active == 1) {
        this.provinceCity();
      }else if (active == 2) {
        this.getSubject();
        this.areaActiveName = command.identification;
        this.changeAreaTabelTab({name: command.identification})
      }else if (active == 6) { // 各链接采集量公众网民版,来源
        console.log("this.toolData1",this.toolData);
        this.getSource();
      } else if (active == 5) { // 推荐单位采集量
        this.unitActiveName = command.identification;
        this.changeUnitTabelTab({name: command.identification})
      } else if (active == 8) {
          this.volunteerActiveName = command.identification;
          this.getVolunteerTabData(command.identification)
      } else if (active == 10) {
          this.posterActiveName = command.identification;
          this.changePosterTabelTab({
            active: 10,
            name: command.identification
          })
      } else if (active == 11) { // 高校
        this.UniversityActiveName = command.identification;
        this.getSchool(command.identification)
      } else if (active == 12) { // 高校
        this.getTesidence();
      }
      this.activeTab.forEach(e => {
        e.show = false;
        if (e.active == active) {
          e.show = true;
          this.nowActive = e;
          return
        }

      });
      this.showMap = false; // 切换时隐藏地图
      this.showBar = false;
    },
    changeTheme() {
      this.$confirm('是否切换主题?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        if(this.theme.isRed) {
          this.theme= {
            isRed: false,
            bg: 'bg2025_2.png',
            bgColor: "#977EFE",
            themeColor: "#595FC0",
            otherBgColor: "#EA3E14",
            lableBg: 'lable2025_2.png',
            tabbt: 'tabbt2025_2.png',
            tabsBg: 'custom-tabs-no-red',
            textColor: 'blue'
          };
        }else {
          this.theme= {
            isRed: true,
            bg: 'bg2025_1.png',
            bgColor: "#FD9B64",
            themeColor: "#EA3E14",
            otherBgColor: "#2AA1FF",
            tabbt: 'tabbt2025_1.png',
            tabsBg: 'custom-tabs-red',
            lableBg: 'lable2025_1.png',
            textColor: 'red'
          }
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    changeProvince(val) {
      // provinceList: [],
      // cityList: [],
      this.cityList = [];
      if(!!val) {
        let cityData = this.provinceList.filter(item => item.province === val)
        this.cityList = cityData[0].childrenList;
      }
    },
    // 查询栏目点击搜索
    searchEvent() {
      if (this.nowActive.active == 6) { // 各链接采集量公众网民版,来源
        console.log("this.toolData3",this.toolData);
        this.getSource();
      } else if (this.nowActive.active == 5) { // 推荐单位采集量
        if(this.unitActiveName === 'second') {
          this.getRemarkUnit();
        }else if(this.unitActiveName === 'three'){
          this.getJointUnit();
        }else {
          this.getUnit();
        }
      } else if (this.nowActive.active == 8) {
        this.getVolunteerTabData(this.volunteerActiveName);
      } else if (this.nowActive.active == 11) {
        this.getSchool(this.UniversityActiveName);
      } else if (this.nowActive.active == 12) {
        this.getTesidence();
      }
    },
    // 全国企业采集量
    worldCollect() {
      this.dialogRecommendTable = true;
      this.dialogRecommendLoading = true;
      this.dialogRecommendTitle = "全国企业采集量";

      this.dialogRecommendData = this.firmList;
      this.dialogRecommendLoading = false;
    },
    findIdByCategoryName(categories, categoryName) {
      for (let i = 0; i < categories.length; i++) {
        if (categories[i].categoryName === categoryName) {
          return categories[i].id; // 返回找到的第一个匹配项的 id
        }
        if (categories[i].children && categories[i].children.length > 0) {
          const id = this.findIdByCategoryName(categories[i].children, categoryName);
          if (id) return id; // 如果在子级中找到匹配项，返回其 id
        }
      }
      return null; // 如果没有找到匹配项，返回 null
    },
    byCategoryFindTop(categoryName, congratulationSize) {
      let categoryIdList = []
      if(categoryName === '学校') { // 要包括高校
        ['学校', '高校'].forEach(element => {
          let id = this.findIdByCategoryName(this.sortList, element);
          if(id) {
            categoryIdList.push(id);
          }
        });
      }else {
        const id = this.findIdByCategoryName(this.sortList, categoryName);
        if(id) {
          categoryIdList.push(id);
        }
      }
      let params = {
        congratulationSize: congratulationSize,
        categoryIdList: categoryIdList,
      }
      apiInstance.post(`${this.urlBase}/myd/count/${this.apiStr}/congratulation`, params).then(res => {
        let { data } = res;
        if(!!data.data.cacheDeadLineDesc) {
          this.updateTime = data.data.cacheDeadLineDesc;
        }
        if(categoryName === '学校') {
          this.educationTop = data.data.childrenList || [];
          this.showWorldTop = false;
          this.showFirmTop = false;
          this.showEducationTop = true;
          this.showIframe = true;
        }else if(categoryName === '企业') {
          this.companyTop = data.data.childrenList || [];
          this.showWorldTop = false;
          this.showEducationTop = false;
          this.showFirmTop = true;
          this.showIframe = true;
        }
        this.dialogRecommendLoading = false;
      }).catch( err => {
        this.loading = false;
        this.dialogRecommendLoading = false;
        this.$message.error('出错了，请联系工作人员！');
      });
    },
    educationCollect(categoryName) {
      this.isWord = false;
      this.dialogRecommendData = []; // 初始化
      let categoryIdList = []
      if(categoryName === '学校') { // 要包括高校
        ['学校', '高校'].forEach(element => {
          let id = this.findIdByCategoryName(this.sortList, element);
          if(id) {
            categoryIdList.push(id);
          }
        });
      }else {
        const id = this.findIdByCategoryName(this.sortList, categoryName);
        categoryIdList = [id];
      }
      this.dialogRecommendLoading = true;
      this.dialogRecommendTitle = `全国${categoryName}采集量`;
      this.loading = true;
      let params = {
        sourceName: '',
        province: '',
        categoryIdList: categoryIdList,
        city: '',
      }
      apiInstance.post(`${this.urlBase}/myd/count/${this.apiStr}/associatedName`, params).then(res => {
        let { data } = res;
        if(!!data.data.cacheDeadLineDesc) {
          this.updateTime = data.data.cacheDeadLineDesc;
        }
        if(!!data.data.childrenList) {
          let childrenList = JSON.parse(JSON.stringify(data.data.childrenList));
          this.dialogRecommendData = this.addTotal(childrenList);
        }
        this.loading = false;
        this.dialogRecommendLoading = false;
        this.dialogRecommendTable = true;
        this.isWord = true;
      }).catch( err => {
        this.loading = false;
        this.dialogRecommendLoading = false;
        this.$message.error('出错了，请联系工作人员！');
      });

    },
    cityCollect() {
      this.cityTableDataTop100 = [];
      this.loading = true;
      this.dialogcityTopLoading = true;
      // 获取城市top100
      apiInstance.post(`${this.urlBase}/myd/count/${this.apiStr}/city/top`, {}).then(res => {
        let { data } = res;
        this.dialogcityTop = true;
        // 更新缓存时间
        // if(!!data.data.cacheDeadLineDesc) {
        //   this.updateTime = data.data.cacheDeadLineDesc;
        // }
        // // 初始化数据容器
        if(!!data.data.childrenList) {
          this.cityTableDataTop100 = data.data.childrenList
        }
        this.dialogcityTopLoading = false;
        this.loading = false;
      }).catch( error => {
        this.dialogcityTopLoading = false;
        this.loading = false;
        this.$message.error('出错了，请联系工作人员！');
      });
    },
    areaCityCollect() {
      this.areaCityTableDataTop100 = [];
      this.loading = true;
      this.dialogAreaCityTopLoading = true;
      // 获取城市top100
      apiInstance.post(`${this.urlBase}/myd/count/${this.apiStr}/submit/address/top`, {}).then(res => {
        let { data } = res;
        this.dialogAreaCityTop = true;
        // 更新缓存时间
        // if(!!data.data.cacheDeadLineDesc) {
        //   this.updateTime = data.data.cacheDeadLineDesc;
        // }
        // // 初始化数据容器
        if(!!data.data.childrenList) {
          this.areaCityTableDataTop100 = data.data.childrenList
        }
        this.dialogAreaCityTopLoading = false;
        this.loading = false;
      }).catch( error => {
        this.dialogAreaCityTopLoading = false;
        this.loading = false;
        this.$message.error('出错了，请联系工作人员！');
      });
    },
    // 省市统计
    provinceCity() {
      this.loading = true;
      this.tableDataLoading = true;
      apiInstance.post(`${this.urlBase}/myd/count/${this.apiStr}/city`, {}).then(res => {
        let { data } = res;
        // 更新缓存时间
        if(!!data.data.cacheDeadLineDesc) {
          this.updateTime = data.data.cacheDeadLineDesc;
        }
        // 初始化数据容器
        this.dealBarData = [];
        if(!!data.data.childrenList) {
          // 过滤数据，过滤掉包含“志愿服务支队”
          let filteredData = this.filterData(data.data.childrenList, '志愿服务支队');
          //排序
          let childrenList = filteredData.sort(function (a, b) {
            return (b.totalAmount) - (a.totalAmount);
          });
          this.dealBarData = JSON.parse(JSON.stringify(childrenList));
          childrenList = this.getChild(childrenList);
          this.getsumrow(childrenList)
          this.provincesAndCitiesData = childrenList; // 省市实际采集量
        }
        this.tableDataLoading = false;
        this.loading = false;
      }).catch( error => {
        this.tableDataLoading = false;
        this.loading = false;
        this.$message.error('出错了，请联系工作人员！');
      });
    },
    filterData(arr=[], str='' ) {
      return arr.filter(item => {
        // 如果当前项包含“志愿服务支队”，则不保留该项
        if (item.name.includes(str)) {
          return false;
        }
        // 递归过滤子级
        if(item.hasOwnProperty('childrenList')) {
          item.childrenList = this.filterData(item.childrenList, str);
        }
        return true;
      });
    },
    addTotal(arr=[]) {
      if (!!arr&&arr.length>0) {
        const addKeys = new Set([
          'amount',
          'employmentAmount',
          'publicAmount',
          'specialAmount',
          'percent',
          'totalAmount',
          'totalPublicAmount',
          'totalEmployeeAmount',
          'totalPercent',
          'publicSpecialAmount',
          'employmentSpecialAmount',
          'stageTotalAmount',
          'firstStageTotalAmount'
        ]);
        let total = arr.reduce((acc, cur) => {
          for (const key in cur) {
            if(typeof acc[key] === 'undefined') {
              acc[key] = 0;
            }
            if(addKeys.has(key)) {
              acc[key] += cur[key];
            }else {
              acc[key] = ''
            }
          }
          return acc;
        }, {});

        if(this.nowActive.active === 1) {
          total.category = '/';
          total.city = '合计';
        }else {
          total.category = '合计';
          total.city = '/';
        }
        total.id = '0';
        total.name = '/';
        total.province = '/';
        total.sourceName = '/';
        total.associatedName = '/';
        total.startCompany = '/';
        total.totalPercentDesc = '100%';
        arr.unshift(total);
      }
      return arr
    },
    //province省->city市->district区->sourceName来源
    getChild(data=[], idx='') {
      if(!!data && data.length > 0) {
        data.forEach((element,index) => {
          if(!idx) {
            element.id = index + 1;
          }else {
            element.id = idx + '-' + ( index + 1 );
          }
          let count = this.countCharacterOccurrences(element.id, '-')
          if(count === 0 && element.province!=="组委会" ) { // 0当前是省，1当前是市、
            element.childrenList.forEach(it => {
              it.province = element.province;
            });
          }
          if(element.hasOwnProperty('childrenList') && element.childrenList.length > 0) {
            element.isClick = true;
            this.getChild(element.childrenList, element.id)
          }else {
            element.childrenList = [];
            element.isClick = false;
          }
        });
      }
      return data;
    },
    // 判断某个字符在字符串中出现的次数
    countCharacterOccurrences(string, character) {
      let count = 0;
      for (let i = 0; i < string.length; i++) {
        if (string.charAt(i) === character) {
          count++;
        }
      }
      return count;
    },
    async loadMore() {
      if (this.loadedCollectBaseList.length >= this.collectBaseList.length) return;
      this.busy = true;
      // 模拟分批加载
      const nextChunk = this.collectBaseList.slice(
        this.loadedCollectBaseList.length,
        this.loadedCollectBaseList.length + this.chunkSize
      );
      this.loadedCollectBaseList = [...this.loadedCollectBaseList, ...nextChunk];
      this.busy = false;
    },
    // 来源统计：搜索查所有limit=0，默认查100以上limit=100
    getSource() {
      this.loading = true;
      this.thePublicLoading = true;
      let categoryId = null;
      this.collectBaseList = [];
      this.loadedCollectBaseList = [];
      if (!!this.toolData.category&&this.toolData.category.length > 0) {
        categoryId = this.toolData.category.at(-1);
      }
      let limit = null;
      if(!!this.toolData.sourceName||!!this.toolData.province||!!categoryId||!!this.toolData.city) {
        limit=0;
      }else {
        limit=20;
      }
      let params = {
        sourceName: this.toolData.sourceName,
        province: this.toolData.province,
        categoryId: categoryId,
        city: this.toolData.city,
        limit: limit,
      }
      apiInstance.post(`${this.urlBase}/myd/count/${this.apiStr}/city/source`, params, { timeout: 20000 }).then(res => {
        let { data } = res;
        // 更新缓存时间
        if(!!data.data.cacheDeadLineDesc) {
          this.updateTime = data.data.cacheDeadLineDesc;
        }
        let childrenList = JSON.parse(JSON.stringify(data.data.childrenList));
        if(!!childrenList) {
          if( this.toolData.sourceName.includes('志愿服务支队') ) {
            this.collectBaseList = []
          }else {
            this.collectBaseList = childrenList.filter(item => {
              // 如果当前项包含“志愿服务支队”，则不保留该项
              if (item.sourceName.includes('志愿服务支队')) {
                return false;
              }
              return true;
            });
            if(this.collectBaseList.length>0&&!!data.data.summation&&Object.keys(data.data.summation).length!==0) {
              this.collectBaseList.unshift(data.data.summation);
            }
            this.loadMore()
          }
          this.provinceList = data.data.provinceList;
        }
        this.thePublicLoading = false;
        this.loading = false;
      }).catch( err => {
        this.thePublicLoading = false;
        this.loading = false;
        this.$message.error('出错了，请联系工作人员！');
      });
		},

    // 按单位统计
    getUnit() {
      this.loading = true;
      this.recommendTableDataLoading = true;
      let params = {
        startCompany: this.toolData.recommended,
      }
      apiInstance.post(`${this.urlBase}/myd/count/${this.apiStr}/company`, params).then(res => {
        let { data } = res;
        if(!!data.data.cacheDeadLineDesc) {
          this.updateTime = data.data.cacheDeadLineDesc;
        }
        if(!!data.data.childrenList) {
          let childrenList = data.data.childrenList
          this.getsumrow(childrenList)
          this.initiateTableData = this.addId(childrenList); // 发起单位
        }
        this.recommendTableDataLoading = false;
        this.loading = false;
      }).catch( err => {
        this.recommendTableDataLoading = false;
        this.loading = false;
        this.$message.error('出错了，请联系工作人员！');
      });
    },
    getsumrow(data) {
      if(!!data&&data.length > 0) {
        const addKeys = new Set([
          'amount',
          'employmentAmount',
          'publicAmount',
          'specialAmount',
          'percent',
          'totalAmount',
          'totalPublicAmount',
          'totalEmployeeAmount',
          'totalPercent',
          'publicSpecialAmount',
          'employmentSpecialAmount',
          'stageTotalAmount',
          'firstStageTotalAmount',
          'stageTotalPercent'
        ]);
        let total = data.reduce((acc, cur) => {
          for (const key in cur) {
            if(typeof acc[key] === 'undefined') {
              acc[key] = 0;
            }
            if(addKeys.has(key)) {
              acc[key] += cur[key];
            }else {
              acc[key] = ''
            }
          }
          return acc;
        }, {});
        total.id = '0';
        if(addKeys.has('percent')) {
          total.percentDesc = `${(total.percent*100).toFixed(0)}%`;
        }
        if(addKeys.has('totalPercent')) {
          total.totalPercentDesc = `${(total.totalPercent*100).toFixed(0)}%`;
        }
        if(addKeys.has('stageTotalPercent')) {
          total.stageTotalPercentDesc = `${(total.stageTotalPercent*100).toFixed(0)}%`;
        }
        total.name = '合计';
        total.startCompany = '合计';
        data.unshift(total);
      }
    },
    // 推荐单位
    getRemarkUnit() {
      this.loading = true;
      this.recommendTableDataLoading = true;
      let params = {
        remarks: this.toolData.recommended,
      }
      apiInstance.post(`${this.urlBase}/myd/count/${this.apiStr}/remark`, params).then(res => {
        let { data } = res;
        if(!!data.data.cacheDeadLineDesc) {
          this.updateTime = data.data.cacheDeadLineDesc;
        }
        if(!!data.data.childrenList) {
          let childrenList = data.data.childrenList
          this.getsumrow(childrenList)
          this.recommendTableData = this.addId(childrenList); // 推荐单位
        }
        this.recommendTableDataLoading = false;
        this.loading = false;
      }).catch( err => {
        this.recommendTableDataLoading = false;
        this.loading = false;
        this.$message.error('出错了，请联系工作人员！');
      });
    },
    // 联合发起单位
    getJointUnit() {
      this.loading = true;
      this.recommendTableDataLoading = true;
      let params = {
        unionStartCompany: this.toolData.recommended,
      }
      apiInstance.post(`${this.urlBase}/myd/count/${this.apiStr}/company/union`, params).then(res => {
        let { data } = res;
        if(!!data.data.cacheDeadLineDesc) {
          this.updateTime = data.data.cacheDeadLineDesc;
        }
        if(!!data.data.childrenList) {
          let childrenList = data.data.childrenList.sort(function (a, b) {
            return (b.totalAmount) - (a.totalAmount);
          });
          this.getsumrow(childrenList) // 加合计列
          this.jointTableData = this.addId(childrenList); // 推荐单位
        }
        this.recommendTableDataLoading = false;
        this.loading = false;
      }).catch( err => {
        this.recommendTableDataLoading = false;
        this.loading = false;
        this.$message.error('出错了，请联系工作人员！');
      });
    },
    addId(data=[], idx='') {
      if(!!data && data.length > 0) {
        data.forEach((element,index) => {
          if(!idx) {
            element.id = index;
          }else {
            element.id = idx + '-' + ( index + 1 );
          }
          if(element.hasOwnProperty('childrenList') && element.childrenList.length > 0) {
            element.isClick = true;
            this.addId(element.childrenList, element.id)
          }else {
            element.childrenList = [];
            element.isClick = false;
          }
        });
      }
      return data
    },
    getSchool(identification) {
      this.schoolTableData = [];
      this.loading = true;
      this.schoolLoading = true;
      let params = {};
      let url = ''
      if(identification === 'first') {
        params = { university: this.toolData.university };
        url = `/myd/count/${this.apiStr}/countByUniversity`;
      }else if(identification === 'second') {
        url = `/myd/count/${this.apiStr}/countByUniversity/area`;
      }else if(identification === 'three') {
        url = `/myd/count/${this.apiStr}/countByUniversity/province`;
      }
      if(!url) {
        this.schoolLoading = false;
        this.loading = false;
        return false
      }
      apiInstance.post(`${this.urlBase}${url}`, params).then(res => {
        let { data } = res;
        if(!!data.data.cacheDeadLineDesc) {
          this.updateTime = data.data.cacheDeadLineDesc;
        }
        if(!!data.data.childrenList) {
          let childrenList = data.data.childrenList
          this.getsumrow(childrenList)
          this.schoolTableData = this.addId(childrenList); // 发起单位
        }
        this.schoolLoading = false;
        this.loading = false;
      }).catch( err => {
        this.schoolLoading = false;
        this.loading = false;
        this.$message.error('出错了，请联系工作人员！');
      });
    },
    getTesidence() {
      this.tesidenceTableData = [];
      this.loading = true;
      this.tesidenceLoading = true;
      let params = {}
      apiInstance.post(`${this.urlBase}/myd/count/${this.apiStr}/countByBaseTopicArea`, params).then(res => {
        let { data } = res;
        if(!!data.data.cacheDeadLineDesc) {
          this.updateTime = data.data.cacheDeadLineDesc;
        }
        if(!!data.data.childrenList) {
          let childrenList = data.data.childrenList
          this.getsumrow(childrenList)
          this.tesidenceTableData = this.addId(childrenList); // 发起单位
        }
        this.tesidenceLoading = false;
        this.loading = false;
      }).catch( err => {
        this.tesidenceLoading = false;
        this.loading = false;
        this.$message.error('出错了，请联系工作人员！');
      });
    },
    // 点击推荐单位
    clickRecommend(row) {
      this.isWord = false; // 非全国企业和全国学校
      this.dialogRecommendData = [];
      this.dialogRecommendTable = true;
      this.dialogRecommendLoading = true;
      this.dialogRecommendTitle = row.name;
      if(!!row.sourceList && row.sourceList.length > 0) {
        let childrenList = []
        if(this.nowActive.active === 1) { // 用主问卷排序
          childrenList = JSON.parse(JSON.stringify(row.sourceList));
          childrenList = childrenList.sort(function (a, b) {
            return (b.totalAmount) - (a.totalAmount);
          });
          this.dialogRecommendData = this.addTotal(childrenList);
          // let addTotalData = this.addTotal(childrenList);
          // this.dialogRecommendData = addTotalData.filter(item => {
          //   // 如果当前项包含“志愿服务支队”，则不保留该项
          //   if (item.sourceName.includes('志愿服务支队')) {
          //     return false;
          //   }
          //   return true;
          // });
        }else {
          childrenList = JSON.parse(JSON.stringify(row.sourceList));
          this.dialogRecommendData = this.addTotal(childrenList);
        }
      }
      this.dialogRecommendLoading = false;
    },
    getVolunteerTabData(identification) {
      this.volunteerTabTableData = [];
      this.loading = true;
      this.volunteerLoading = true;
      this.showMap = false;
      this.showBar = false;
      let params = {
        volunteerOrgName: '',
        volunteerUnitName: '',
        sourceName: '',
        otherVolunteerOrgName: '',
        publicInstructor: ''
      }
      let url = ''
      if(identification === 'first') {
          url = `/myd/count/${this.apiStr}/volunteer/orgName`;
          params.volunteerOrgName = this.toolData.volunteerOrgName;
      }else if(identification === 'second') {
          url = `/myd/count/${this.apiStr}/volunteer/unitName`;
          params.volunteerUnitName = this.toolData.volunteerOrgName;
      }else if(identification === 'three') {
          url = `/myd/count/${this.apiStr}/volunteer/person`;
          params.volunteer = this.toolData.volunteerOrgName;
      }else if(identification === 'four') {
          url = `/myd/count/${this.apiStr}/volunteer/other`;
          params.otherVolunteerOrgName = this.toolData.volunteerOrgName;
      }else if(identification === 'five') {
          url = `/myd/count/${this.apiStr}/volunteer/instructor`;
          params.publicInstructor = this.toolData.volunteerOrgName;
      }
      apiInstance.post(`${this.urlBase}${url}`, params).then(res => {
        let { data } = res;
        if(!!data.data.cacheDeadLineDesc) {
          this.updateTime = data.data.cacheDeadLineDesc;
        }
        if(!!data.data.childrenList) {
          let childrenList = data.data.childrenList.sort(function (a, b) {
            return (b.totalAmount) - (a.totalAmount);
          });
          this.getsumrow(childrenList) // 加合计列
          this.volunteerTabTableData = this.addId(childrenList);
        }
        this.volunteerLoading = false;
        this.loading = false;
      }).catch( error => {
        this.volunteerLoading = false;
        this.loading = false;
        this.$message.error('出错了，请联系工作人员！');
      });
    },

    // 参与答题网民区域分布,专题统计接口：/myd/count/city/address/
    getSubject() {
      this.loading = true;
      this.subjectLoading = true;
      this.tableDataAreaLoading = true;
      apiInstance.post(`${this.urlBase}/myd/count/${this.apiStr}/city/address/special`, {}).then(res => {
        let { data } = res;
        if(!!data.data.cacheDeadLineDesc) {
          this.updateTime = data.data.cacheDeadLineDesc;
        }
        if(!!data.data.childrenList) {
          let childrenList = data.data.childrenList;
          this.getAreaChild(childrenList)
          this.getsumrowSubject(childrenList)
          this.subjectTableData = childrenList;
          this.totalAreaData = childrenList;
        }
        this.subjectLoading = false;
        this.tableDataAreaLoading = false;
        this.loading = false;
      }).catch( error => {
        this.subjectLoading = false;
        this.tableDataAreaLoading = false;
        this.loading = false;
        this.$message.error('出错了，请联系工作人员！');
      });
    },
    getAreaChild(data=[], idx='') {
      if(!!data && data.length > 0) {
        data.forEach((element,index) => {
          if(!idx) {
            element.id = index+1;
          }else {
            element.id = idx + '-' + (index+1);
          }
          let count = this.countCharacterOccurrences(element.id, '-')
          element.sublist = [];
          if(count === 0 ) { // 0当前是省，1当前是市
            element.sublist = element.childrenList;
            if(element.province!=="组委会") {
              let arr = [];
              element.childrenList.forEach(it => {
                it.province = element.province;
                if(it.city!=="协会" && it.city!=="组委会") {
                  arr.push(it)
                }
              });
            }
          }
          if(element.hasOwnProperty('childrenList') && element.childrenList.length > 0) {
            element.isClick = true;
            this.getAreaChild(element.childrenList, element.id)
          }else {
            element.childrenList = [];
            element.isClick = false;
          }
        });
      }
    },
    getsumrowSubject(data) {
      if(data.length>0) {
        const total = data.reduce((acc, cur) => {
          for (const key in cur) {
            if (typeof acc[key] === 'undefined') {
              acc[key] = 0;
            }
            if (typeof cur[key] === 'number') {
              acc[key] += cur[key];
            }
          }
          return acc;
        }, {});
        total.id = '0';
        total.name = '合计';
        total.specialPercentDesc = '100.00%';
        total.percentDesc = '100.00%';
        total.childrenList = [];
        total.isClick = false;
        data.unshift(total);
      }
    },
    //获取分类
    func_get_sort() {
      // /form/source/category/hierarchicalList
      apiInstance.post(`${this.urlBase}/form/source/category/hierarchicalList`,{
        year: this.year
      },{
        Accept: "application/json"
      }).then(res => {
        let { data } = res;
        this.sortList = data.data
        this.changeTab(this.nowActive.active)
      }).catch( error => {
        this.$message.error('出错了，请联系工作人员！');
      });
    },
    tableRowClassName({row, rowIndex}) {
      if (rowIndex === 0) {
        return 'success-row';
      }
      return '';
    },
    changeUnitTabelTab({name}) {
      this.recommendTableDataLoading = true;
      this.toolData.recommended = '';
      let ref= '';
      if(name=='second') {
        this.getRemarkUnit();
      }else if(name=='three') {
        this.getJointUnit();
      }else {
        this.getUnit();
      }
      setTimeout(()=>{
        this.recommendTableDataLoading = false;
      },100)
    },
    changeAreaTabelTab({name}) {
      this.tableDataAreaLoading = true;
      this.subjectLoading = true;
      setTimeout(()=>{
        this.tableDataAreaLoading = false;
        this.subjectLoading = false;
      },100)
    },
    changeVolunteerTabelTab({name}) {
      this.getVolunteerTabData(name)
    },
    changeUniversityTabelTab({name}) {
      this.toolData.university = '';
      this.getSchool(name)
    },
    // 喜报墙
    changePosterTabelTab({active,name}) {
      this.showMap = false;
      this.showBar = false;
      let nowObj = this.activeTab.find(item => item.active === active);
      let children = nowObj.children.find(item => item.identification === name);
      this.nowPosterData = children;
      let categoryId = null;
      if(this.nowPosterData.title === '发起单位') {
        this.loading = true;
        Promise.all([
          apiInstance.post(`${this.urlBase}/myd/count/${this.apiStr}/company`, {}),
          apiInstance.post(`${this.urlBase}/myd/count/${this.apiStr}/company/union`, {})
        ]).then(([units, jointUnits]) => {
          // 将获取到的数据保存到 data 对象中
          let unitsData = units.data.data.childrenList || [];
          let jointUnitsData = jointUnits.data.data.childrenList || [];
          this.nowPosterData.topList.forEach(it => {
            it.topData = []
            if(it.name=== '发起单位' && unitsData.length > 0) {
              // 排序：降序
              unitsData.sort((a, b) => (b.amount+b.specialAmount) - (a.amount+a.specialAmount));
              // 获取前10个元素
              it.topData = unitsData.slice(0, 10);
            }else if(it.name=== '联合发起单位' && jointUnitsData.length > 0) {
              // 排序：降序
              jointUnitsData.sort((a, b) => (b.amount+b.specialAmount) - (a.amount+a.specialAmount));
              // 获取前10个元素
              it.topData = jointUnitsData.slice(0, 10);
            }
          });
          this.loading = false;
        }).catch(error => {
          this.loading = false;
          console.error('请求数据失败:', error);
        });
      }else if(this.nowPosterData.title === '志愿服务团体(个人)') {
        this.loading = true;
        Promise.all([
          apiInstance.post(`${this.urlBase}/myd/count/${this.apiStr}/volunteer/orgName`, {}),
          apiInstance.post(`${this.urlBase}/myd/count/${this.apiStr}/volunteer/unitName`, {}),
          apiInstance.post(`${this.urlBase}/myd/count/${this.apiStr}/volunteer/person`, {}),
          apiInstance.post(`${this.urlBase}/myd/count/${this.apiStr}/volunteer/other`, {}),
          apiInstance.post(`${this.urlBase}/myd/count/${this.apiStr}/volunteer/instructor`, {}),
        ]).then(([orgName, unitName, person, other, instructor]) => {
          // 将获取到的数据保存到 data 对象中
          let orgNameData = orgName.data.data.childrenList || [];
          let unitNameData = unitName.data.data.childrenList || [];
          let personData = person.data.data.childrenList || [];
          let otherData = other.data.data.childrenList || [];
          let instructorData = instructor.data.data.childrenList || [];
          this.nowPosterData.topList.forEach(it => {
            it.topData = []
            if(it.name=== '网安联·志愿服务站' && orgNameData.length > 0) {
              // 排序：降序
              orgNameData.sort((a, b) => (b.amount+b.specialAmount) - (a.amount+a.specialAmount));
              // 获取前10个元素
              it.topData = orgNameData.slice(0, 10);
            }else if(it.name=== '网安联·志愿服务队' && unitNameData.length > 0) {
              // 排序：降序
              unitNameData.sort((a, b) => (b.amount+b.specialAmount) - (a.amount+a.specialAmount));
              // 获取前10个元素
              it.topData = unitNameData.slice(0, 10);
            }else if(it.name=== '志愿者' && personData.length > 0) {
              // 排序：降序
              personData.sort((a, b) => (b.amount+b.specialAmount) - (a.amount+a.specialAmount));
              // 获取前10个元素
              it.topData = personData.slice(0, 10);
            }else if(it.name=== '其他志愿服务团体' && otherData.length > 0) {
              // 排序：降序
              otherData.sort((a, b) => (b.amount+b.specialAmount) - (a.amount+a.specialAmount));
              // 获取前10个元素
              it.topData = otherData.slice(0, 10);
            }else if(it.name=== '网安联公益讲师' && instructorData.length > 0) {
              // 排序：降序
              instructorData.sort((a, b) => (b.amount+b.specialAmount) - (a.amount+a.specialAmount));
              // 获取前10个元素
              it.topData = instructorData.slice(0, 10);
            }
          });
          this.loading = false;
        }).catch(error => {
          this.loading = false;
          console.error('请求数据失败:', error);
        });
      }else {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        this.sortList.forEach(element => {
          if(element.categoryName === this.nowPosterData.title&&!!element.id) {
            categoryId = element.id;
            this.nowPosterData.topList.forEach(element => {
              element.topData = []
              if(!!element.name) {
                const id = this.findIdByCategoryName(this.sortList, element.name);
                this.setTopData(id, (list) => {
                  // 使用list
                  element.topData = list;
                })
              }
            });
          }
        });
        setTimeout(() => {
          loading.close();
        }, 0);
      }
    },
    setTopData(categoryId, callback) {
      let params = {
        categoryId: categoryId,
        congratulationSize: 10,
      }
      apiInstance.post(`${this.urlBase}/myd/count/${this.apiStr}/congratulation`, params).then(res => {
        let { data } = res;
        if(!!data.data.cacheDeadLineDesc) {
          this.updateTime = data.data.cacheDeadLineDesc;
        }
        let list = data.data.childrenList || []; // data.data.childrenList; 获得的数据
        if(callback) callback(list);
      }).catch( err => {
        this.$message.error('出错了，请联系工作人员！');
      });
    },
    // 选择tab,改变表格数据
    changeTab(active) {
      this.loading = true;
      try {
        this.showMap = false; // 切换时隐藏地图
        this.showBar = false;
        // 切换按钮
        this.activeTab.forEach(e => {
          e.show = e.active === active;
          if (e.active === active) {
            this.nowActive = e;
          }
        });
        // 重置查询条件
        this.resetToolData();
        // 请求对应tab下的表格数据
        this.fetchDataForTab(active);
      } catch (error) {
        this.loading = false;
      }
    },
    fetchDataForTab(active) {
      const fetchDataMap = {
        1: this.provinceCity,
        2: this.getSubject,
        6: () => {
          console.log("this.toolData2",this.toolData);
          this.getSource();
        },
        5: this.getUnit,
        8: () => {
          this.volunteerActiveName = 'first';
          this.getVolunteerTabData('first');
        },
        10: () => {
          const nowObj = this.activeTab.find(item => item.active === 10);
          this.nowPosterData = nowObj.children[0];
          this.posterActiveName = 'first';
          this.changePosterTabelTab({
            active: 10,
            name: this.nowPosterData.identification
          });
        },
        11: () => {
          this.UniversityActiveName = 'first';
          this.getSchool('first');
        },
        12: this.getTesidence,
      };
      const fetchDataFunction = fetchDataMap[active];
      if (fetchDataFunction) {
        fetchDataFunction();
      } else {
        console.warn(`No fetch function defined for active tab: ${active}`);
      }
      this.loading = false;
    },
    resetToolData() {
      this.toolData = {
        category: '',
        sourceName: '',
        sourceId: '',
        province: '',
        recommended: '',
        volunteerOrgName: '',
        volunteerUnitName: '',
        city: '',
        university: ''
      };
    },
		// 导出数据功能
		exportData() {
      this.loading = true;
			let params = {};
			let url = '';
			if(this.nowActive.active == 1) { // 各省市实际采集量
				url = `${this.urlBase}/myd/export/${this.apiStr}/city`;
			}else if(this.nowActive.active == 2) { // 参与答题网民区域分布
        if(this.areaActiveName==='first') { // 发起
          params = {
            activeSheetIndex: 0,
          }
        }else if(this.areaActiveName==='second') { // 发起
          params = {
            activeSheetIndex: 1,
          }
        }
        url = `${this.urlBase}/myd/export/${this.apiStr}/special`
			}else if(this.nowActive.active == 5) { // 单位
        if(this.unitActiveName==='first') { // 发起
          params = {
            startCompany: this.toolData.recommended,
            unionStartCompany: '',
            activeSheetIndex: 0,
          }
          url = `${this.urlBase}/myd/export/${this.apiStr}/company`;
        }else if(this.unitActiveName==='three') { // 联合发起
          params = {
            startCompany: '',
            unionStartCompany: this.toolData.recommended,
            activeSheetIndex: 1,
          }
          url = `${this.urlBase}/myd/export/${this.apiStr}/company`;
        }
			}else if(this.nowActive.active == 6) { // 各链接
				url = `${this.urlBase}/myd/export/${this.apiStr}/source`;
        let categoryId = null;
        if (!!this.toolData.category&&this.toolData.category.length > 0) {
          categoryId = this.toolData.category.at(-1);
        }
        params = {
          sourceName: this.toolData.sourceName,
          province: this.toolData.province,
          categoryId: categoryId,
          city: this.toolData.city,
        }
			}else if(this.nowActive.active == 8) { // 志愿服务机构
        let activeSheetIndex = 0;
        if(this.volunteerActiveName==='first') { // 志愿服务站 0
          activeSheetIndex = 0;
        }else if(this.volunteerActiveName==='second') { // 志愿服务队 1
          activeSheetIndex = 1;
        }else if(this.volunteerActiveName==='three') { // 志愿者 4
          activeSheetIndex = 4;
        }else if(this.volunteerActiveName==='four') { // 其他志愿团体 2
          activeSheetIndex = 2;
        }else if(this.volunteerActiveName==='five') { // 公益讲师 3
          activeSheetIndex = 3;
        }
				url = `${this.urlBase}/myd/export/${this.apiStr}/volunteer`;
        params = {
          activeSheetIndex: activeSheetIndex,
        }
			}else if(this.nowActive.active == 11) {
        url = `${this.urlBase}/myd/export/${this.apiStr}/university`;
        params = {
          university: this.toolData.university,
        }
      }else if(this.nowActive.active == 12) {
        url = `${this.urlBase}/myd/export/${this.apiStr}/baseTopicArea`;
        params = {}
      }
			apiInstance({
				method: 'post',
				url: url,
				data: params,
				responseType: 'arraybuffer'
			}).then(res => {
        this.loading  = false;
          if(this.canUseBlobDownload()) {
          let filename = this.nowActive.active === 5
            ? `${this.year}发起单位(联合发起单位).xlsx`
            : `${this.year}${this.nowActive.title}${this.nowActive.titleS}${this.nowActive.titleF}.xlsx`;
          let blob = new Blob([res.data], {
						type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
				  })
          let a = document.createElement("a"); // 创建a标签
          a.style.display = "none";
          let objectUrl = URL.createObjectURL(blob);
          a.download = filename;
          a.href = objectUrl;
          a.click();
          URL.revokeObjectURL(objectUrl);
        }else {
          alert('当前环境不支持直接导出，请使用浏览器打开播报链接进行导出');
          this.loading  = false;
        }
			}).catch( error => {
        this.loading  = false;
        this.$message.error('导出出错了，请联系工作人员！');
      });;
		},
    canUseBlobDownload() {
      return isBlobDownloadSupported() && !isWeChatAndroid();
    },
    barEvent() {
      this.showMap = false;
      this.showBar = true;
      let dealBarData = this.func_deal_barData(this.dealBarData);
      setTimeout(()=> {
        this.initBarChart(dealBarData);
      }, 0)
    },
    func_deal_barData(data) {
      let dealData = []
      let features = [];
      features = this.geojsonData.features;
      data.forEach(item => {
        if(!!item.province) {
          dealData.push({
            name: `${item.province}`,
            showText: `${dealData.length+1}  ${item.province}`,
            value: (item.totalAmount / 10000).toFixed(2),
          })
        }
      });
      // 防止有遗漏的省市，影响地图初始化
      features.forEach(i => {
        let result = dealData.some(item => {
          return item.name === i.properties.name
        })
        if (!result && i.properties.name!=='十段线'&& i.properties.name!=='南海诸岛') {
          dealData.push({
            name: `${i.properties.name}`,
            showText: `${dealData.length+1}  ${i.properties.name}`,
            value: 0.00,
          })
        }
      });
      return dealData || [];
    },
    initBarChart(chartData) {
      var chartDom = document.getElementById('barContainer');
      let myChart = echarts.init(chartDom);
      var option;
      const names = chartData.map(item => item.showText);
      const values = chartData.map(item => item.value);
      myChart.setOption(
        (option = {
        title: {
          text: '', // 标题
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {},
        grid: {
          left: '4%',
          right: '60px',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          name: '单位/万',
        },
        yAxis: {
          data: names,
          inverse: true, // 将 Y 轴倒序显示
        },
        series: [
          {
            name: '', // 标签
            type: 'bar',
            data: values,
            itemStyle: {
              color: '#34C998' // 固定颜色
            }
          },
        ],
      })
      );
      option && myChart.setOption(option);
    },
    // 地图
    mapEvent() {
      this.showBar = false;
      this.showMap = true;
      // 开始画地图
      let data = [];
      if (this.nowActive.active == 2) { //参与答题网民区域分布
        data = this.subjectTableData;
      } else if (this.nowActive.active == 1) {
        data = this.provincesAndCitiesData;
      }
      this.dealMapData = this.func_deal_map(data); // 处理地图数据

      setTimeout(() => {
        this.func_init_map(); // 初始化地图
      })
    },
		tableEvent() {
			this.showMap = false;
			this.showBar = false;
		},
    func_init_map() {
      let geoJson = this.geojsonData;
      var chartDom = document.getElementById('mapContainer');
      myChart = echarts.init(chartDom);
      var option;
      echarts.registerMap('china', geoJson);
      myChart.setOption(
        (option = {
          title: {
            text: '',
            left: 'center',
            subtext: '',
            sublink:
              'http://zh.wikipedia.org/wiki/%E9%A6%99%E6%B8%AF%E8%A1%8C%E6%94%BF%E5%8D%80%E5%8A%83#cite_note-12'
          },
          toolbox: {
            feature: {
              myTool1: {
                show: true,
                title: '放大',
                icon: 'image://https://survey.iscn.org.cn/system/mallMiniProgram/img/dataReport/amplification.png',
                onclick: function (res) {
                  myChart.setOption({
                    series: [{
                      zoom: res.option.series[0].zoom + 0.5,
                      roam: 'move'
                    }]
                  });
                }
              },
              myTool2: {
                show: true,
                title: '还原',
                icon: 'image://https://survey.iscn.org.cn/system/mallMiniProgram/img/dataReport/restore.png',
                onclick: function (res) {
                  myChart.setOption({
                    series: [{
                      zoom: 1.1,
                      roam: 'move'
                    }]
                  });
                }
              }
            }

          },
          tooltip: {
            trigger: 'item',
            // triggerOn: 'item', //点击才显示tooltip，item 图形触发，axis 坐标轴触发， none 不触发
            borderWidth: 0,
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            // formatter: '答卷数<br/>{b}:{c}'
            formatter: function (param) {
              return param.marker + " " + param.seriesName + "<br>"
                + "&nbsp;&nbsp;&nbsp;&nbsp;" + param.name + "：" + param.value + "<br>";
            }
          },
          visualMap: {
            top: 'top',
            type: "continuous",
            min: 0,
            max: 300000,
            realtime: false,
            calculable: true,
            inRange: {
              color: ['#25B0F3', '#0000CD']
            }
          },
          series: [
            {
              name: '答卷次数',
              type: 'map',
              roam: 'move',//true即为缩放+拖动
              left: "10%",                                 //组件离容器左侧的距离,百分比字符串或整型数字
              top: "10%",                                      //组件离容器上侧的距离，百分比字符串或整型数字
              right: "10%",                               //组件离容器右侧的距离,百分比字符串或整型数字
              bottom: "10%",                              //组件离容器下侧的距离,百分比字符串或整型数字
              map: 'china',
              zoom: 1.1,
              itemStyle: {
                emphasis: {
                  // 鼠标悬浮地图区域的高亮颜色
                  areaColor: '#90ED87'
                }
              },
              label: {
                normal: {
                  show: true,
                  textStyle: {
                    fontSize: 10,
                    fontWeight: '',
                    color: '#fff' //修改地图上文字的颜色
                  }
                },
                emphasis: {
                  textStyle: {
                    color: '#000'
                  }
                }
              },
              select: {
                lable: {
                  color: '#fff'
                },
                itemStyle: {
                  areaColor: '#90ED87'
                }
              },
              data: this.dealMapData
            }
          ]
        })
      );
      option && myChart.setOption(option);
    },
    // 处理地图数据
    func_deal_map(mapObj) {
      let dealData = []
      let features = [];
      features = this.geojsonData.features;
      const sum = Object.values(mapObj.reduce((accumulator, current) => {
        const { province, amount, specialAmount } = current;

        if (!accumulator[province]) {
          accumulator[province] = { province, amount: 0, specialAmount: 0 };
        }

        accumulator[province].amount += (amount + specialAmount);

        return accumulator;
      }, {}));
      sum.forEach(item => {
        if(!!item.province) {
          dealData.push({
            name: `${item.province}`,
            value: item.amount,
            label: {
              normal: {
                show: true,
                formatter: function (params) {
                  return item.amount;
                },
              }
            },
          })
        }

      });
      // 防止有遗漏的省市，影响地图初始化
      features.forEach(i => {
        let result = dealData.some(item => {
          return item.name === i.properties.name
        })
        if (!result) {
          dealData.push({
            name: i.properties.name,
            value: 0,
            label: {
              normal: {
                show: true,
                formatter: function (params) {
                  return 0;
                },
              }
            },
          })
        }
      });
      return dealData || [];
    },
    // 各省市总数Top10
		openIframe(type) {
      let data = []
			if(this.provincesAndCitiesData.length>0) { // 总数Top10
        // this.provincesAndCitiesData
        this.provincesAndCitiesData.some(item => {
          if (item.name && item.name !== '/' && item.name !== '合计') {
            data.push({ name: item.name });
          }
          return data.length >= 10; // 如果 data.length >= 10，返回 true 提前退出
        });
        this.provincesAndCitiesTop = data;
        this.showWorldTop = true;
        this.showFirmTop = false;
        this.showEducationTop = false;
			}else {
        this.provincesAndCitiesTop = [];
        this.showWorldTop = true;
        this.showFirmTop = false;
        this.showEducationTop = false;
      }
			this.showIframe = true;
		},
    treePropsLoad(tree, treeNode, resolve) {
      // 模拟异步加载子节点数据
      setTimeout(() => {
        const children = tree.childrenList || [];
        resolve(children);
      }, 500);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container-box {
  width: 100%;
  height: 100%;
  padding-bottom: 50px;
  background-size: 100% auto !important;
}
.calcu-content {
  min-height: 450px;
  margin: 0 auto;
  padding-bottom: 50px;
  border-radius: 0 0 10px 10px;
  padding-top: 17.4%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.tidings-wall-box {
  position: fixed;
  top: 15%;
  right: 0.5%;
  text-align: right;
  z-index: 99;
}
.content-start {
  position: fixed;
  top: 25%;
  right: 0.5%;
  text-align: right;
  z-index: 99;
}
.content-title {
  width: 80%;
  text-align: center;
}
.content-subhead {
  width: 32%;
  text-align: center;
}
.content-btn {
  width: 60%;
  line-height: 35px;
  font-size: 18px;
  text-align: center;
  color: #fff5bf;
	margin-bottom: 10px;
}
.content-btn .btn-box {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.content-btn .btn-box .btn-box-bg {
	cursor: pointer;
  width: 15%;
  background-size: contain !important;
  background-repeat: no-repeat;
  background-position: center center;
}
.content-table {
  width: 93%;
  position: relative;
  overflow: hidden;
}
.innerBg {
  width: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 1;
  position: relative;
}
.innerBg img {
  width: 100%;
  height: auto;
  border: 0;
  max-width: 100%;
  display: block;
}
.innerBg-box {
  background-image: linear-gradient(
    rgba(255, 255, 255, 0.5),
    rgba(255, 255, 255, 1)
  );
  overflow: hidden;
  margin-top: -6.5%;
  padding-top: 7%;
}
.tab-box {
  background: #fff;
  margin-top: -2px;
  padding-top: 4px;
}
.tab-title {
  text-align: center;
  font-weight: bold;
  font-size: 32px;
  padding-bottom: 25px;
}
.selection-area {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: auto 6%;
}
.selection-area .sel-tab {
  flex: 1;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  margin: 0 10px;
	padding: 0 10px;
  height: 50px;
  color: #fff;
  font-size: 20px;
  text-align: center;
  cursor: pointer;
  display: flex;
	flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
  min-width: 52px;
}
.selection-area .sel-tab div {
	flex: 1;
}
.selection-area .add-tips {
  font-size: 12px;
}
.tips-6 {
  width: 100%;
  text-align: right;
  font-size: 14px;
  padding: 5px 2px;
  color: red;
}
.table-box {
  margin: auto;
  background: #fff;
  padding-bottom: 40px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  margin-top: -2px;
  /* max-height: 1500px; */
  min-height: 540px;
}
.table-box .table {
  margin: auto 6%;
}
.table-box .table .sel-header {
  margin: 0;
  color: #fff;
  font-size: 20px;
  text-align: center;
  display: -webkit-flex;
  display: flex;
  justify-content: center;
  position: relative;
}
.table .sel-tips {
  width: 100%;
  margin: 10px auto;
}
.table .update-time {
  text-align: right;
  padding-right: 10px;
  color: #fff;
  cursor: pointer;
  font-size: 12px;
}
.table .update-time span {
	margin-left: 2px;
}
.table .tips-top {
  text-align: left;
  padding-top: 10px;
  padding-left: 10px;
  color: #fff;
  cursor: pointer;
  font-size: 12px;
  margin-bottom: -12px;
}
.table .tips-top span {
  display: inline-block;
  margin-right: 5px;
  line-height: 20px;
  text-decoration: underline;
  cursor:pointer;
}
.top-link:hover {
  color: #0a0a0a;
}
.table .tool-bar {
  margin: 10px auto;
  display: flex;
  justify-content: center;
}
.end-tool-bar {
  display: flex;
  justify-content: flex-end!important;
}
.tool-bar .tool-input {
  margin-bottom: 10px;
}
.tool-input .el-select {
  width: 100%;
}
.table .caculate-area {
  width: 100%;
  margin: 0 auto 0;
  min-height: 50px;
  /* height: 750px; */
  position: relative;
  background: #fff;
}
.caculate-area .data-scroll-area {
  /* border: 1px solid #ddd; */
  /* overflow: auto; */
}
.dialog-box {
  /* height: 90%;
  max-height: 670px; */
  overflow: auto;
}
.iframe-box {
  width: 100%;
  display: flex;
  justify-content: center;
}
/* tab样式 */
.tabs-box {
  margin: 20px auto;
}
.tabs-box /deep/ .el-tabs__nav-scroll {
  display: flex;
  justify-content: center;
}
.tabs-box /deep/ .el-tabs--card>.el-tabs__header {
  /* border: none; */
}
.tabs-box /deep/ .el-table {
  border: 1px solid #ddd;
}
.tabs-box /deep/ .el-tabs__header {
  margin: 0;
}
.tabs-box /deep/ .el-tabs__nav {
  border: none;
  width: 100%;
  display: flex;
  justify-content: center;
}
.tabs-box /deep/ .el-tabs--card>.el-tabs__header .el-tabs__item:first-child {
  border: 1px solid #ddd;
}
.tabs-box /deep/ .el-tabs__item {
  border-radius: 5px 5px 0 0;
  border: 1px solid #ddd;
  width: 20%;
  text-align: center;
  padding: 0!important;
}
.tabs-box-2 /deep/ .el-tabs__item {
  min-width: 200px;
}
.tabs-box /deep/ .el-tabs--card>.el-tabs__header .el-tabs__nav {
  border: none;
}
.tabs-box /deep/ .el-tabs__item:hover {
  color: #ddd;
  /* color: #303133; */
}
.tabs-box /deep/ .el-tabs__item.is-active {
  color: #fff;
  /* background-color: #F89A67; */
}
.tabs-title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}
.custom-tabs-red /deep/ .el-tabs__item.is-active {
  background-color: #F79A67;
}
.custom-tabs-no-red /deep/ .el-tabs__item.is-active {
  background-color: #9C95DA;
}
.caculate-area /deep/ .el-table .cell {
  padding-left: 5px;
  padding-right: 5px;
  /* transform: scale(0.8); */
  line-height: 20px;
}
.total-table /deep/ .el-table__footer-wrapper {
    position: absolute;
    top: 48px;
    left: 0;
}
.total-table /deep/ .el-table__body-wrapper {
    margin-top: 46px;
}
.total-table-2 /deep/ .el-table .success-row {
  background: #F5F7FA;
  position: sticky;
  top: 0px;
  background-color: #f5f7fa;
  z-index: 1;
}
.total-table-3 /deep/ th {
  border: 2px solid #ebeef5;
}
.total-table-3 /deep/ td {
  border: 2px solid #ebeef5;
}
.total-table-3 /deep/ .el-table th.el-table__cell>.cell {
  white-space: pre-line;
}
.content-box-title {
  font-size: 28px;
  font-weight: 600;
  text-align: center;
}
.flex-right {
  display: flex;
  justify-content: flex-end;
}
.caculate-area /deep/ .el-table .cell {
  padding-left: 0px!important;
  padding-right: 0px!important;
}
.caculate-area /deep/ .el-table .el-table__indent {
  padding-left: 0px!important;
}
.dialog-container /deep/ .el-table .cell {
  padding-left: 0px!important;
  padding-right: 0px!important;
}
@media screen and (max-width: 1950px) {
}
@media screen and (max-width: 1500px) {
  .content-btn {
    line-height: 28px;
    font-size: 16px;
  }
  .selection-area .sel-tab {
    font-size: 16px;
  }
}
@media screen and (max-width: 1200px) {
  .content-table {
    width: 96%;
  }
  .table-box .table {
    margin: auto 3%;
  }
  .content-btn {
    line-height: 24px;
    font-size: 14px;
  }
  .selection-area .sel-tab {
    font-size: 14px;
    margin: auto 4px;
    height: 40px;
  }
  .tab-title {
    font-size: 28px;
  }
}
@media screen and (max-width: 1024px) {
  .content-btn {
    line-height: 20px;
    font-size: 12px; /*最小了 ，后面可用缩放*/
  }
  .table-box .table .sel-header {
    font-size: 18px;
  }
  .tab-title {
    font-size: 26px;
  }
  .selection-area .sel-tab {
    margin: auto 2px;
    padding: 0 5px;
    font-size: 12px;
    min-width: 32px;
  }
}
@media screen and (max-width: 768px) {
  .selection-area .sel-tab {
    height: 45px;
    min-width: 30px;
  }
  .selection-area .long-3-sel-tab {
    min-width: 38px!important;
  }
  .selection-area .long-4-sel-tab {
    min-width: 52px!important;
  }
  .selection-area .long-5-sel-tab {
    min-width: 60px!important;
  }
  .tips-6 {
    font-size: 12px;
    padding: 0 0 2px 0;
  }
  .table .tool-bar {
    margin: 10px auto;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
  }
  .tool-bar .tool-input {
    padding-bottom: 10rpx;
  }
  .tool-bar /deep/ .el-input__inner {
    padding: 0 10px;
  }
  .content-table {
    width: 95%;
  }
  .selection-area, .table-box .table {
    margin: auto 1%;
  }
  .selection-area .sel-tab {
    margin: auto 2px;
    padding: 0 4px;
    justify-content: center;
  }
  .content-btn {
    line-height: 14px;
  }
  .table-box .table .sel-header {
    font-size: 14px;
  }
  .tab-title {
    font-size: 16px;
    padding-bottom: 5px
  }
  .table .tips-top {
    margin-bottom: 0;
    font-size: 10px;
  }
  .tabs-box /deep/ .el-tabs__item {
    height: 38px;
    line-height: 38px;
    font-size: 12px;
  }
  .caculate-area /deep/ .el-button,.dialog-container /deep/ .el-button {
    padding: 2px 2px;
  }
  .caculate-area /deep/ .el-table {
    font-size: 12px;
    overflow: overlay;
  }
  .caculate-area /deep/ .el-table .cell {
    padding-left: 0px!important;
    padding-right: 0px!important;
    /* transform: scale(0.8); */
  }
  .caculate-area /deep/ .el-table .el-table__placeholder {
    width: 0px!important;
  }
  .caculate-area /deep/ .el-table .el-table__cell {
    text-align: center!important;
    padding: 5px 0;
    /* line-height: 20px; */
  }
  .total-table /deep/ .el-table__footer-wrapper {
    position: absolute;
    top: 48px;
    left: 0;
    height: 30px;
  }
  .total-table /deep/ .el-table__body-wrapper {
    margin-top: 28px;
  }
  .dialog-container /deep/ .el-table {
    font-size: 12px!important;
    padding: 0;
    margin: 0;
    width: 100%;
  }
  .dialog-container /deep/ .el-table .cell {
    padding-left: 0px;
    padding-right: 0px;
    font-size: 12px!important;
    /* transform: scale(0.8); */
    line-height: 20px;
  }
  .dialog-container /deep/ .el-table .el-table__placeholder {
    width: 0px;
  }
  .dialog-container /deep/ .el-table .el-table__cell {
    text-align: center;
    padding: 2px 0;
  }
  .dialog-container /deep/ .el-dialog--center .el-dialog__body {
    padding: 5px 5px 30px;
  }
  .dialog-top /deep/ .el-dialog--center .el-dialog__body {
    padding: 30px 5px 20px;
  }
  .dialog-Poster /deep/ .el-dialog--center .el-dialog__body {
    padding: 10px 5px 20px;
    min-width: 350px;
    max-width: 420px;
  }
  .caculate-area /deep/ .el-table [class*=el-table__row--level] .el-table__expand-icon {
    width: 10px;
    margin-left: -10px;
  }
  .caculate-area /deep/ .el-table .el-table__indent {
    padding: 0!important;
  }
  .dialog-container /deep/ .el-table [class*=el-table__row--level] .el-table__expand-icon {
    width: 10px;
    margin-left: -10px;
  }
  .dialog-container /deep/ .el-table .el-table__indent {
    padding: 0!important;
  }
  .tabs-box /deep/ .el-tabs__nav {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .tabs-box-3 /deep/ .el-tabs__item {
    width: 32%;
    text-align: center;
  }
  .tabs-box-2 /deep/ .el-tabs__item {
    width: 48%;
    text-align: center;
  }
  .caculate-area /deep/ .el-table {
    padding: 0;
    margin: 0;
    width: 100%;
  }
  .caculate-area /deep/ .el-table th {
    /* 恢复正常字体大小 */
    font-size: 12px !important;
  }
  .caculate-area /deep/ .el-table th.is-center {
    padding: 2px 0;
    margin: 0;
    float: none;
    line-height: 20px;
  }
  .content-box-title {
    font-size: 22px;
  }
  .iframe-box {
    width: 100%;
  }
}
@media screen and (max-width: 550px) {
  .content-btn {
    line-height: 12px;
  }
}
@media screen and (max-width: 400px) {
  .selection-area .sel-tab {
    margin: auto 2px;
    padding: 0 2px;
  }
}
@media screen and (max-width: 352px) {
  .table .tool-bar {
    margin: 0px;
  }
  .content-btn {
    line-height: 10px;
  }
  .selection-area .sel-tab {
    margin: auto 1px;
    padding: 0 1px;
    min-width: 28px;
  }
}
</style>
<style>
.custom-tabs-no-red li {
  background-color: #9C95DA;
  border: 1px solid #9C95DA;
  color: #fff !important;
  font-size: 20px !important;
}
.custom-tabs-no-red li:hover {
  border-radius: 5px;
  color: #9C95DA !important;
}
.custom-tabs-red li {
  background-color: #F79A67;
  border: 1px solid #F79A67;
  color: #fff !important;
  font-size: 20px !important;
}
.custom-tabs-red li:hover {
  border-radius: 5px;
  color: #F79A67 !important;
}
.el-dropdown-menu {
  /* background-color: #1A74EA !important ;
  border: 1px solid #1A74EA !important ; */
  border-radius: 0px;
  min-width: 180px!important;
  margin-top: 0px;
  margin: 0px 0px 0px 10px!important;
  padding: 0px!important;
  font-size: 24px!important;
  z-index: 99!important;
}
.el-popper[x-placement^=bottom]{
  margin-top: 0px;
  margin-bottom: 0px;
  padding: 0px;
}
.el-dropdown-menu__item:not(:last-of-type){
  border-bottom:1px solid #fff;
}
/* 消除小三角 */
.el-popper[x-placement^=bottom] .popper__arrow{
  border: none;
}
.el-popper[x-placement^=bottom] .popper__arrow::after{
  border: none;
}
@media screen and (max-width: 768px) {
  .custom-tabs-no-red li {
    font-size: 12px !important;
    line-height: 24px!important;
  }
  .custom-tabs-red li {
    font-size: 12px !important;
    line-height: 24px!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue